import React, { useEffect, useState, useContext, useRef } from 'react';
import { Select, DatePicker, Radio, Button, Modal, Table, Spin } from 'antd';
import http from '../../Http';
import utils from '../../utils';
import config from "../../Config";
import moment from 'moment';
import ReactECharts from 'echarts-for-react';
import { ReloadOutlined } from '@ant-design/icons';
import Monitor from '../../Monitor';
import calc from './calc.js';
import CRC from './RemoteSetting/ModbusCRC';
import { useTranslation } from 'react-i18next';
import WebSocketController from "../../WebSocketController";
import BatteryAlarmDefs from './RealtimeMonitorUhomeSinglePhaseCombination/BatteryAlarmDefs';
import SenergyAlarmHandler from './RealtimeMonitor/SenergyAlarmHandler';
import MegarevoAlarmHandler from './RealtimeMonitor/MegarevoAlarmHandler';
import SinexcelAlarmHandler from './RealtimeMonitor/SinexcelAlarmHandler';
import MegarevoCESSAlarmHandler from './RealtimeMonitor/MegarevoCESSAlarmHandler';
import ThinkpowerAlarmHandler from './RealtimeMonitor/ThinkpowerAlarmHandler';
import SungeryAlarmHandler from './RealtimeMonitor/SungeryAlarmHandler';
import SFCConfigurationAndSchedules from './RealtimeMonitor/SFCConfigurationAndSchedules';


const option1 = {
    tooltip: {
        trigger: 'item',
        formatter: `{b}<br/>Brands: <b>{d}%</b>`,
        textStyle: {
            fontSize: 12
        },
    },
    color: ['#5CC9A0', '#F2A474'],
    series: [
        {
            type: 'pie',
            radius: '50%',
            showEmptyCircle: true,
            label: { show: false },
            data: [],
        }
    ]
}

const option2 = {
    tooltip: {
        trigger: 'item',
        formatter: `{b}<br/>Brands: <b>{d}%</b>`,
        textStyle: {
            fontSize: 12
        },
    },
    color: ['#5CC9A0', '#F2A474'],
    series: [
        {
            type: 'pie',
            radius: '50%',
            showEmptyCircle: true,
            label: { show: false },
            data: [],
        }
    ]
}

const powerOption = {
    tooltip: {
        trigger: 'axis'
    },
    legend: {
        data: ['Solar PV', 'Battery', 'Grid', 'Consumption', 'SOC']
    },
    xAxis: {
        type: 'category',
        data: [],
        name: '(Time)',
        nameLocation: "center",
        nameGap: 25,
        axisLabel: {
            formatter: (value) => {
                return moment(value).format('HH:mm')
            }
        }
    },
    yAxis: [{
        type: 'value',
        name: 'Power(W)',
        splitNumber: 5,
    }, {
        type: 'value',
        name: 'SOC(%)',
        alignTicks: true,
        max: 100,
        min: 0,
        splitNumber: 5,
        interval: 20,
    }],
    series: []
}

const energyOption = {
    tooltip: {
        trigger: 'axis'
    },
    legend: {
        data: []
    },
    xAxis: {
        type: 'category',
        data: [],
        name: '(Time)',
        nameLocation: "center",
        nameGap: 25,
    },
    yAxis: {
        type: 'value',
        name: '(kWh)',
        nameLocation: "middle",
        nameRotate: 90,
        nameGap: 40,
    },
    series: []
}

function RealtimeMonitor(props) {
    const { t } = useTranslation();
    const { inverterSelectOptions, SN, ID, protocol, model, isBalcony, handleSelectSN } = props
    const setTip = useContext(utils.tipContext)

    const [invData, setInvData] = useState(null)  //当前选择的逆变器的详细数据
    const [solarIndex, setSolarIndex] = useState(0)  //点击solar面板
    const [batteryIndex, setBatteryIndex] = useState(0)  //点击battery面板
    const [gridIndex, setGridIndex] = useState(0)  //点击grid面板

    const chart1 = useRef(null)
    const chart2 = useRef(null)
    const powerChart = useRef(null)
    const energyChart = useRef(null)

    const [powerDate, setPowerDate] = useState(moment().format('YYYY-MM-DD')) //power的时间
    const [size, setSize] = useState('monthly')  //月, 年, 总计
    const [energyDate, setEnergyDate] = useState(moment().format('YYYY-MM-DD')) //energy的时间

    const [refresh, setRefresh] = useState(false)

    const [showInvertersList, setShowInvertersList] = useState(false)

    const [ParallelInfo, setParallelInfo] = useState({
        IsParallel: false,
        ParallelSN: 0
    }) //并网逆变器的SN

    const [loading, setLoading] = useState(false);
    const [smartPlugStatus, setSmartPlugStatus] = useState(null);

    const [sns, setSNs] = useState();
    const [batSNs, setBatSNs] = useState();
    const [dailyData, setDailyData] = useState([]); //日数据
    const [monthlyData, setMonthlyData] = useState([]); //月数据
    const [yearlyData, setYearlyData] = useState([]); //年数据
    const [totalData, setTotalData] = useState([]); //总数据
    const [timezone, setTimezone] = useState('UTC'); //时区    
    const [batteryCount, setBatteryCount] = useState(0); //电池数量
    const [batteryAlarms, setBatteryAlarms] = useState([]); //电池报警信息
    const [batteryAlarmsFromInverters, setBatteryAlarmsFromInverters] = useState([]); //电池报警信息(来自逆变器)
    const [inverterAlarms, setInverterAlarms] = useState([]); //逆变器报警信息
    const [snMapToSFCAssetID, setSnMapToSFCAssetID] = useState({}); //SN映射到SFC的资产ID
    const [showSFCComponent, setShowSFCComponent] = useState(true); //控制SFC组件的显示

    const refInvData = useRef();
    const refDailyData = useRef([]);
    const refMonthlyData = useRef([]);
    const refYearlyData = useRef([]);
    const refTotalData = useRef([]);
    const refPowerDate = useRef(powerDate);
    const refEnergyDate = useRef(energyDate);
    const refSize = useRef(size);
    const refInverters = useRef([]);

    //2025.1.15
    let hasSmartPlug = false
    if (protocol == "Sungery" && invData) {
        if (invData.OnGirdSet == 5) {
            hasSmartPlug = true;
        }
    }

    useEffect(() => {
        if (!SN) return;
        setSNs([SN]);
    },[SN]);

    useEffect(() => {
        option1.tooltip.formatter = `{b}<br/>${t('Brands')}: <b>{d}%</b>`;
        option2.tooltip.formatter = `{b}<br/>${t('Brands')}: <b>{d}%</b>`;
        powerOption.legend.data = [t('Solar PV'), t('Battery'), t('Grid'), t('Consumption'), t('SOC')];
        powerOption.xAxis.name = t('(Time)');
        powerOption.yAxis.name = t('Power(W)');
        energyOption.xAxis.name = t('(Time)');
    }, [t]);

    //get inverter rt-data
    useEffect(async() => {
        if (!SN) {
            return;
        }
        let active = true;

        try {
            let resp = await http.post("integrated-inverter/last/pvi/get", { SerialNumber: ParallelInfo.ParallelSN || SN }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                return null;
            });

            if (!active) {
                return;
            }

            if (resp === null || resp.code !== 200) {
                setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load inverter details error") });
                refInvData.current = null;
                setInvData(null)
                return;
            }

            if (protocol === 'Sungery') {
                //给Paralles数组排序
                resp.data.Parallels.sort((a, b) => {
                    return a.ParaMode != b.ParaMode ? a.ParaMode - b.ParaMode : b.ExtCtGetHostEn - a.ExtCtGetHostEn;
                })
                setParallelInfo({ ...ParallelInfo, IsParallel: resp.data.IsParallel })
            }

            refInvData.current = resp.data;
            setInvData(resp.data);
            setTimezone(resp.data.Timezone??"UTC");

            const d = resp.data;
            let batSns = [];
            let sns = [SN];
            if (d.Parallels) {
                d.Parallels.forEach((v) => {
                    v.SN && sns.push(v.SN);
                })
            }
            if (sns.length > 0) {
                sns = [...new Set(sns)];
                setSNs(sns)
            }
            if (d.Batteries) {
                d.Batteries.forEach((v) => {
                    v.SN && batSns.push(v.SN);
                })
                batSns = batSns.concat(sns);
                batSns = [...new Set(batSns)];
                setBatSNs(batSns); //电池SN和逆变器SN合并
            }

            //2025.6.11
            if (d.SFCAssetID) {
                setSnMapToSFCAssetID((prev) => {
                    return { ...prev, [SN]: d.SFCAssetID };
                });
            }
        } catch (e) {
            console.log("[Inverter-Monitor]", e)
        } finally {
            active = false;
        }

        return () => {
            active = false;
        }; 
    }, [SN, ParallelInfo.ParallelSN])

    //get inverter daily data
    useEffect(async() => {
        if (!SN) return;
        let active = true;

        let resp = await http.post("integrated-inverter/report/daily/report", {
            SerialNumber: ParallelInfo.ParallelSN || SN,
            Date: powerDate,
        }).then(async (r) => {
            return await r.json();
        }).catch((e) => {
            return null;
        });

        if (!active) {
            return;
        }

        if (resp === null || resp.code !== 200) {  //请求日数据失败
            setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load inverter record error") });
            return;
        }

        refDailyData.current = resp.data
        setDailyData(refDailyData.current);

        return () => {
            active = false;
        };

    }, [SN, powerDate, refresh, ParallelInfo.ParallelSN]);

    //get inverter monthly/yearly/all-years data
    useEffect(async() => {
        if (!SN || (size != "monthly" && size != "yearly" && size != "all-years")) return;
        let active = true;
        
        let resp = await http.post(`integrated-inverter/report/${size}/report`, {
            SerialNumber: ParallelInfo.ParallelSN || SN,
            Date: moment(energyDate).format('YYYY-MM') + '-01'
        }).then(async (r) => {
            return await r.json();
        }).catch((e) => {
            return null;
        });

        if (!active) {
            return;
        }

        if (resp === null || resp.code !== 200) {  
            setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load inverter record error") });
            return;
        } 

        if (size == "monthly") {
            refMonthlyData.current = resp.data
            setMonthlyData(refMonthlyData.current);
        } else if (size == "yearly") {
            refYearlyData.current = resp.data
            setYearlyData(refYearlyData.current);
        } else if (size == "all-years") {
            refTotalData.current = resp.data
            setTotalData(refTotalData.current);
        }

        return () => {
            active = false;
        };

    }, [SN, size, energyDate, refresh, ParallelInfo.ParallelSN]);

    //handle invData
    useEffect(() => {
        if (!invData) return;

        const invs = {[invData.SerialNumber]: invData};
        invData.Parallels && invData.Parallels.forEach(v => {
            (!invs[v.SN]) && (invs[v.SN] = v);
        });
        refInverters.current = Object.values(invs);

        //对Sungery阳台经济的特殊处理
        if (protocol === 'Sungery') {
            const IBat = calc.current(invData.IBat, protocol)
            const VBat = calc.voltage(invData.VBat, protocol)
            invData.PBat = IBat * VBat
            const relatedInverters = invData.relatedInverters
            if (relatedInverters && relatedInverters.length > 0) {
                for (let i = 0; i < relatedInverters.length; i++) {
                    relatedInverters[i].PBat = calc.current(relatedInverters[i].IBat, protocol) *
                        calc.voltage(relatedInverters[i].VBat, protocol)
                }
            }
            //根据OnGridSet的值(1-无CT, 2-有CT)来决定负载功率是否为0 
            //OnGridSet=1(无CT): 负载功率置0，电网功率=市电有功功率(LinePowerW_A)
            //OnGridSet=2(有CT)：负载功率=NormalLoadW_A，电网功率=电网测有功功率(GridPowerW_A)
            if (invData.OnGirdSet == 1) { //无CT
                invData.PAC1LOAD = 0;
                invData.PAC2LOAD = 0;
                invData.PAC3LOAD = 0;
                invData.PAC1GRID = invData.PAC1Line;
                invData.PAC2GRID = invData.PAC2Line;
                invData.PAC3GRID = invData.PAC3Line;
            }
            invData.VAC1GRID = invData.VAC1Line;
            invData.VAC2GRID = invData.VAC2Line;
            invData.VAC3GRID = invData.VAC3Line;
            invData.FACGRID = invData.FACLine;
        }

        //对带符号数的处理
        if (protocol === 'Megarevo' || protocol === 'Sinexcel' || protocol === 'Megarevo-CESS' || protocol === 'Sungery') {
            if (protocol === 'Sungery') {  //阳台经济的并机数据
                invData.ParallelBattSumPower = calc.convertComplement(invData.ParallelBattSumPower, protocol)
                invData.ParallelLineSumPowerW_A = calc.convertComplement(invData.ParallelLineSumPowerW_A, protocol)
                invData.ParallelLineSumPowerW_B = calc.convertComplement(invData.ParallelLineSumPowerW_B, protocol)
                invData.ParallelLineSumPowerW_C = calc.convertComplement(invData.ParallelLineSumPowerW_C, protocol)
            }
            invData.PBat = calc.convertComplement(invData.PBat, protocol)
            invData.PAC1GRID = calc.convertComplement(invData.PAC1GRID, protocol)
            invData.PAC2GRID = calc.convertComplement(invData.PAC2GRID, protocol)
            invData.PAC3GRID = calc.convertComplement(invData.PAC3GRID, protocol)
            invData.PAC1Inv = calc.convertComplement(invData.PAC1Inv, protocol)
            invData.PAC1EPS = calc.convertComplement(invData.PAC1EPS, protocol)
            const relatedInverters = invData.relatedInverters
            if (relatedInverters && relatedInverters.length > 0) {
                for (let i = 0; i < relatedInverters.length; i++) {
                    relatedInverters[i].PBat = calc.convertComplement(relatedInverters[i].PBat, protocol)
                    relatedInverters[i].PAC1GRID = calc.convertComplement(relatedInverters[i].PAC1GRID, protocol)
                    relatedInverters[i].PAC2GRID = calc.convertComplement(relatedInverters[i].PAC2GRID, protocol)
                    relatedInverters[i].PAC3GRID = calc.convertComplement(relatedInverters[i].PAC3GRID, protocol)
                }
            }
        }

        //对Sinexcel工商储的电池能量数据的处理
        if (protocol == 'Sinexcel' && (model == 'EINV125H3-B215' || model == 'EINV125H3-NB172')) {
            let { ETotalBatChrg, ETotalBatDischrg,
                EDayFromGrid, EDayToGrid, ETotalFromGrid, ETotalToGrid } = invData;
            let batToGridRatio = 1.015, gridToBatRatio = 0.985;
            if (ETotalBatChrg > 0 && ETotalFromGrid > 0) {
                gridToBatRatio = ETotalBatChrg / ETotalFromGrid;
            }
            if (ETotalBatDischrg > 0 && ETotalToGrid > 0) {
                batToGridRatio = ETotalBatDischrg / ETotalToGrid;
            }
            invData.EDayBatChrg = EDayFromGrid * gridToBatRatio;
            invData.EDayBatDischrg = EDayToGrid * batToGridRatio;
        }

        //pie图
        option1.series[0].data = [
            { value: invData.EDayBatChrg, name: t('Charge Today') },
            { value: invData.EDayToGrid, name: t('Export Today') },
        ]
        const instance1 = chart1.current && chart1.current.getEchartsInstance();
        if (instance1) {
            instance1.setOption(option1, true);
        }

        option2.series[0].data = [
            { value: invData.ETotalBatChrg, name: t('Charge Total') },
            { value: invData.ETotalToGrid, name: t('Export Total') },
        ]
        const instance2 = chart2.current && chart2.current.getEchartsInstance();
        if (instance2) {
            instance2.setOption(option2, true);
        }

        //告警解析及处理
        let faults1 = []; //for inverter
        let faults2 = []; //for battery
        let faults3 = []; //for battery from inverter
        let batCount = 0; 
        for ( const k in invs) {
            const item = invs[k];
            (item.Batteries??[]).forEach((v) => {batCount += (v.SN?1:0)});

            //处理逆变器报警
            if (protocol == "Senergy") {
                let {InverterAlarms, BatteryAlarms} = {...SenergyAlarmHandler.parseAlarmData(item.ErrorCode1??0, item.ErrorCode2??0)};
                let arr = InverterAlarms.map((v) => {
                    return {
                        From: "Inverter",
                        SN: item.SN,
                        Code: v.Code,
                        Name: v.Name,
                        CreateTime: item.CreateTime
                    };
                });
                faults1.push(...arr);
                arr = BatteryAlarms.map((v) => {
                    return {   
                        From: "Inverter",    
                        SN: item.SN,
                        Code: v.Code,
                        Name: v.Name,
                        CreateTime: item.CreateTime
                    };
                });
                faults3.push(...arr);

            } else if (protocol == "Megarevo") {
                let {InverterAlarms, BatteryAlarms} = {...MegarevoAlarmHandler.parseAlarmData(item)};
                let arr = InverterAlarms.map((v) => {
                    return {
                        From: "Inverter",
                        SN: item.SN,
                        Code: v.Code,
                        Name: v.Name,
                        CreateTime: item.CreateTime
                    };
                });
                faults1.push(...arr);
                arr = BatteryAlarms.map((v) => {
                    return {   
                        From: "Inverter",    
                        SN: item.SN,
                        Code: v.Code,
                        Name: v.Name,
                        CreateTime: item.CreateTime
                    };
                });
                faults3.push(...arr);
            } else if (protocol == "Sinexcel") {
                let {InverterAlarms, BatteryAlarms} = {...SinexcelAlarmHandler.parseAlarmData(item)};
                let arr = InverterAlarms.map((v) => {
                    return {
                        From: "Inverter",
                        SN: item.SN,
                        Code: v.Code,
                        Name: v.Name,
                        CreateTime: item.CreateTime
                    };
                });
                faults1.push(...arr);
                arr = BatteryAlarms.map((v) => {
                    return {   
                        From: "Inverter",    
                        SN: item.SN,
                        Code: v.Code,
                        Name: v.Name,
                        CreateTime: item.CreateTime
                    };
                });
                faults3.push(...arr);
            } else if (protocol == "Megarevo-CESS") { 
                let {InverterAlarms, BatteryAlarms} = {...MegarevoCESSAlarmHandler.parseAlarmData(item)};
                let arr = InverterAlarms.map((v) => {
                    return {
                        From: "Inverter",
                        SN: item.SN,
                        Code: v.Code,
                        Name: v.Name,
                        CreateTime: item.CreateTime
                    };
                });
                faults1.push(...arr);
                arr = BatteryAlarms.map((v) => {
                    return {   
                        From: "Inverter",    
                        SN: item.SN,
                        Code: v.Code,
                        Name: v.Name,
                        CreateTime: item.CreateTime
                    };
                });
                faults3.push(...arr);
            } else if (protocol == "Thinkpower") {
                let {InverterAlarms, BatteryAlarms} = {...ThinkpowerAlarmHandler.parseAlarmData(item.ErrorCode1??0, item.ErrorCode2??0, item.ErrorCode3??0)};
                let arr = InverterAlarms.map((v) => {
                    return {
                        From: "Inverter",
                        SN: item.SN,
                        Code: v.Code,
                        Name: v.Name,
                        CreateTime: item.CreateTime
                    };
                });
                faults1.push(...arr);
                arr = BatteryAlarms.map((v) => {
                    return {   
                        From: "Inverter",    
                        SN: item.SN,
                        Code: v.Code,
                        Name: v.Name,
                        CreateTime: item.CreateTime
                    };
                });
                faults3.push(...arr);
            } else if (protocol == "Sungery") { 
                let {InverterAlarms, BatteryAlarms} = {...SungeryAlarmHandler.parseAlarmData(item.ErrorCode1??0, item.ErrorCode2??0, item.ErrorCode3??0, item.ErrorCode4??0, item.ErrorCode5??0, item.ErrorCode6??0, item.ErrorCode7??0, item.ErrorCode8??0)};
                let arr = InverterAlarms.map((v) => {
                    return {
                        From: "Inverter",
                        SN: item.SN,
                        Code: v.Code,
                        Name: v.Name,
                        CreateTime: item.CreateTime
                    };
                });
                faults1.push(...arr);
                arr = BatteryAlarms.map((v) => {
                    return {   
                        From: "Inverter",    
                        SN: item.SN,
                        Code: v.Code,
                        Name: v.Name,
                        CreateTime: item.CreateTime
                    };
                });
                faults3.push(...arr);
            }
            //处理电池报警
            if (item.Batteries != null) {
                item.Batteries.forEach((item2, index2) => {
                    if (item2.Alarms) {
                        for (let k in item2.Alarms) {
                            if (BatteryAlarmDefs.MapAlarmNameToName2[k] && item2.Alarms[k] != null && item2.Alarms[k] > 0) {
                                faults2.push({
                                    From: "Battery",
                                    SN: item2.SN,
                                    Code: BatteryAlarmDefs.MapAlarmNameToCategorys[k],
                                    Name: t(BatteryAlarmDefs.MapAlarmNameToName2[k]),
                                    Level: item2.Alarms[k],
                                    CreateTime: item2.Alarms.CreateTime
                                });
                            }
                        }
                    }
                });
            }
            faults2.sort((a,b) => a.Code - b.Code);
        };
        setBatteryCount(batCount);
        setInverterAlarms(faults1);
        setBatteryAlarms(faults2);
        setBatteryAlarmsFromInverters(faults3);
        
    }, [invData])

    //handle dailyData
    useEffect(() => {
        if (!dailyData) return;
       
        const xData = []
        const PDC = []
        const PBat = []
        const PGrid = []
        const PLoad = []
        const SOC = []
        //遍历结果，给坐标和数据赋值
        dailyData.forEach(v => {
            const P_bat = protocol === 'Sungery' && ParallelInfo.IsParallel && !ParallelInfo.ParallelSN ? v.ParallelBattSumPower : v.PBat;
            let P_grid1 = protocol === 'Sungery' && ParallelInfo.IsParallel && !ParallelInfo.ParallelSN ? v.ParallelLineSumPowerW_A : v.PAC1GRID;
            const P_grid2 = protocol === 'Sungery' && ParallelInfo.IsParallel && !ParallelInfo.ParallelSN ? v.ParallelLineSumPowerW_B : v.PAC2GRID;
            const P_grid3 = protocol === 'Sungery' && ParallelInfo.IsParallel && !ParallelInfo.ParallelSN ? v.ParallelLineSumPowerW_C : v.PAC3GRID;
            const P_load1 = protocol === 'Sungery' && ParallelInfo.IsParallel && !ParallelInfo.ParallelSN ? v.ParallelNormalSumLoadW_A : v.PAC1LOAD;
            const P_load2 = protocol === 'Sungery' && ParallelInfo.IsParallel && !ParallelInfo.ParallelSN ? v.ParallelNormalSumLoadW_B : v.PAC2LOAD;
            const P_load3 = protocol === 'Sungery' && ParallelInfo.IsParallel && !ParallelInfo.ParallelSN ? v.ParallelNormalSumLoadW_C : v.PAC3LOAD;
            let P_pv = 0;
            if (protocol === 'Thinkpower' || protocol === 'Megarevo' || protocol === 'Sinexcel' || protocol === 'Megarevo-CESS' || protocol === 'Sungery') {
                P_pv = (v.PMPPT1 || 0) + (v.PMPPT2 || 0) + (v.PMPPT3 || 0) + (v.PMPPT4 || 0)
            } else {
                P_pv = v.PDC
            }
            if (protocol === 'Sungery' && ParallelInfo.IsParallel && !ParallelInfo.ParallelSN) {
                P_pv = (Pload1 || 0) + (Pload2 || 0) + (Pload3 || 0) + (Peps1 || 0) + (Peps2 || 0) + (Peps3 || 0) - (Pbat || 0) - (Pgrid1 || 0) - (Pgrid2 || 0) - (Pgrid3 || 0);
                P_pv = P_pv > 0 ? P_pv : 0;
            }
            xData.push(moment(v.YMDH).format('YYYY-MM-DD HH:mm'))
            if (hasSmartPlug == true && invData) { //有智能插座
                P_grid1 = (parseInt(invData.PAC1LOAD)??0) - (parseInt(invData.PAC1Inv)??0) + (parseInt(invData.PAC1EPS)??0) ;
            } 
            if (protocol == "Thinkpower") { //2025.3.27
                if (P_grid1 < -24000 || P_grid1 > 24000) {
                    return;
                }
                if (P_grid2 < -24000 || P_grid2 > 24000) {
                    return;
                }
                if (P_grid3 < -24000 || P_grid3 > 24000) {
                    return;
                }
            }
            PDC.push(calc.power(P_pv, protocol, ParallelInfo.IsParallel && !ParallelInfo.ParallelSN))
            PBat.push(calc.power(P_bat, protocol, ParallelInfo.IsParallel && !ParallelInfo.ParallelSN))
            PGrid.push(calc.power(P_grid1, protocol, ParallelInfo.IsParallel && !ParallelInfo.ParallelSN) + calc.power(P_grid2, protocol, ParallelInfo.IsParallel && !ParallelInfo.ParallelSN) + calc.power(P_grid3, protocol, ParallelInfo.IsParallel && !ParallelInfo.ParallelSN))
            PLoad.push(calc.power(P_load1 + P_load2 + P_load3, protocol, ParallelInfo.IsParallel && !ParallelInfo.ParallelSN))
            SOC.push(calc.soc(v.SOC, protocol))
        })
        //x轴坐标
        powerOption.xAxis.data = xData;
        //处理双y轴坐标刻度的对齐
        const max_y0 = Math.max(...PDC, ...PBat, ...PGrid, ...PLoad)
        const min_y0 = Math.min(...PDC, ...PBat, ...PGrid, ...PLoad)
        powerOption.yAxis[0].max = max_y0
        powerOption.yAxis[0].min = min_y0
        powerOption.yAxis[0].interval = Math.round((max_y0 - min_y0) / 5)
        //数据
        powerOption.series = [
            { name: t('Solar PV'), type: 'line', smooth: true, symbol: 'none', data: PDC, yAxisIndex: 0 },
            { name: t('Battery'), type: 'line', smooth: true, symbol: 'none', data: PBat, yAxisIndex: 0 },
            { name: t('Grid'), type: 'line', smooth: true, symbol: 'none', data: PGrid, yAxisIndex: 0 },
            { name: t('Consumption'), type: 'line', smooth: true, symbol: 'none', data: PLoad, yAxisIndex: 0 },
            { name: t('SOC'), type: 'line', smooth: true, symbol: 'none', data: SOC, yAxisIndex: 1 },
        ]
        //tooltip
        powerOption.tooltip.formatter = (item) => {
            if (!item || item.length == 0) {
                return ''
            }
            let tip = `<b>${t('Time')}: </b>${item[0].name}<br/>`
            for (const v of item) {
                var iBat = 0;
                if (v.seriesName === t('Solar PV')) {
                    tip += `<b>${t('Solar PV')}: </b>${v.value} W<br/>`
                }
                if (v.seriesName === 'IBat') {
                    iBat = v.value
                }
                if (v.seriesName === t('Battery')) {
                    const batPower = v.value
                    let batTip = ''
                    if (protocol === 'Senergy' || protocol === 'Thinkpower' || protocol === 'Sungery') {
                        batTip = batPower > 0 ? t('Battery Discharge') :
                            batPower < 0 ? t('Battery Charge') : t('Battery')
                    } else {
                        batTip = batPower < 0 ? t('Battery Discharge') :
                            batPower > 0 ? t('Battery Charge') : t('Battery')
                    }
                    tip += `<b>${batTip}: </b>${Math.abs(batPower)} W<br/>`
                }
                if (v.seriesName === t('Grid')) {
                    const gridPower = v.value
                    let gridTip = ''
                    if (protocol === 'Senergy' || protocol === 'Sinexcel' || protocol === 'Sungery') {
                        gridTip = gridPower > 0 ? t('Grid Import') :
                            gridPower < 0 ? t('Grid Export') : t('Grid')
                    } else {
                        gridTip = gridPower < 0 ? t('Grid Import') :
                            gridPower > 0 ? t('Grid Export') : t('Grid')
                    }
                    tip += `<b>${gridTip}: </b>${Math.abs(gridPower)} W<br/>`
                }
                if (v.seriesName === t('Consumption')) {
                    tip += `<b>${t('Consumption')}: </b>${v.value} W<br/>`
                }
                if (v.seriesName === t('SOC')) {
                    tip += `<b>${t('SOC')}: </b>${v.value} %<br/>`
                }
            }
            return tip;
        }

        //渲染数据到页面
        //setOption()的第二个参数设为true, 表示组件合并模式为替换合并
        const instance = powerChart.current.getEchartsInstance();
        if (instance) {
            instance.setOption(powerOption, true);
        }
    }, [dailyData]);

    //handle monthlyData
    useEffect(() => {
        if (!SN || !monthlyData) return;

        const y = moment(energyDate).year()
        const m = moment(energyDate).month()
        let days = Array(new Date(y, m + 1, 0).getDate())
        days.fill(0).forEach((v, i) => {
            days[i] = i + 1;
        })
        //坐标
        energyOption.xAxis.data = days;
        energyOption.xAxis.name = t('(Day)');
        energyOption.yAxis.name = t('(kWh)');

        let EDay = Array(days.length).fill(0)
        let EDayBatChrg = Array(days.length).fill(0)
        let EDayBatDischrg = Array(days.length).fill(0)
        let EDayToGrid = Array(days.length).fill(0)
        let EDayFromGrid = Array(days.length).fill(0)
        let EDayToLoad = Array(days.length).fill(0)
        monthlyData.forEach(v => {
            EDay[moment(v['YMD']).date() - 1] = calc.energy(v['EDay'], protocol)
            EDayBatChrg[moment(v['YMD']).date() - 1] = calc.energy(v['EDayBatChrg'], protocol)
            EDayBatDischrg[moment(v['YMD']).date() - 1] = calc.energy(v['EDayBatDischrg'], protocol)
            EDayToGrid[moment(v['YMD']).date() - 1] = calc.energy(v['EDayToGrid'], protocol)
            EDayFromGrid[moment(v['YMD']).date() - 1] = calc.energy(v['EDayFromGrid'], protocol)
            EDayToLoad[moment(v['YMD']).date() - 1] = calc.energy(v['EDayLOAD'], protocol)
            //对Sinexcel工商储的电池能量数据的处理
            if (protocol == 'Sinexcel' && (model == 'EINV125H3-B215' || model == 'EINV125H3-NB172')) {
                let batToGridRatio = 1.015, gridToBatRatio = 0.985;
                if (invData && invData.ETotalBatChrg > 0 && invData.ETotalFromGrid > 0) {
                    gridToBatRatio = invData.ETotalBatChrg / invData.ETotalFromGrid;
                }
                if (invData && invData.ETotalBatDischrg > 0 && invData.ETotalToGrid > 0) {
                    batToGridRatio = invData.ETotalBatDischrg / invData.ETotalToGrid;
                }
                EDayBatChrg[moment(v['YMD']).date() - 1] = Math.round(calc.energy(v['EDayFromGrid'], protocol) * gridToBatRatio);
                EDayBatDischrg[moment(v['YMD']).date() - 1] = Math.round(calc.energy(v['EDayToGrid'], protocol) * batToGridRatio);
            }
        })
        //Echart坐标legend
        energyOption.legend.data = [t('Solar Production'), t('Battery Charge'), t('Battery Discharge'), t('Export to Grid'), t('Import from Grid'), t('Consumption')]
        //Echart数据
        energyOption.series = [{
            name: t('Solar Production'),
            type: 'bar',
            data: EDay
        }, {
            name: t('Battery Charge'),
            type: 'bar',
            data: EDayBatChrg
        }, {
            name: t('Battery Discharge'),
            type: 'bar',
            data: EDayBatDischrg
        }, {
            name: t('Export to Grid'),
            type: 'bar',
            data: EDayToGrid
        }, {
            name: t('Import from Grid'),
            type: 'bar',
            data: EDayFromGrid
        }, {
            name: t('Consumption'),
            type: 'bar',
            data: EDayToLoad
        }]
    
        //渲染数据到页面
        const instance = energyChart.current.getEchartsInstance();
        if (instance) {
            instance.setOption(energyOption, true);
        }
    }, [monthlyData]);

    //handle yearlyData
    useEffect(() => {
        if (!SN || !yearlyData) return;
        //坐标
        energyOption.xAxis.data = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
        energyOption.xAxis.name = t('(Month)');
        energyOption.yAxis.name = t('(kWh)');
           
        let EMon = Array(12).fill(0)
        let EMonBatChrg = Array(12).fill(0)
        let EMonBatDischrg = Array(12).fill(0)
        let EMonToGrid = Array(12).fill(0)
        let EMonFromGrid = Array(12).fill(0)
        let EMonToLoad = Array(12).fill(0)
        yearlyData.forEach(v => {
            EMon[moment(v['YM']).month()] = calc.energy(v['EMon'], protocol)
            EMonBatChrg[moment(v['YM']).month()] = calc.energy(v['EMonBatChrg'], protocol)
            EMonBatDischrg[moment(v['YM']).month()] = calc.energy(v['EMonBatDischrg'], protocol)
            EMonFromGrid[moment(v['YM']).month()] = calc.energy(v['EMonFromGrid'], protocol)
            EMonToGrid[moment(v['YM']).month()] = calc.energy(v['EMonToGrid'], protocol)
            EMonToLoad[moment(v['YM']).month()] = calc.energy(v['EMonLOAD'], protocol)
            //对Sinexcel工商储的电池能量数据的处理
            if (protocol == 'Sinexcel' && (model == 'EINV125H3-B215' || model == 'EINV125H3-NB172')) {
                let batToGridRatio = 1.015, gridToBatRatio = 0.985;
                if (invData && invData.ETotalBatChrg > 0 && invData.ETotalFromGrid > 0) {
                    gridToBatRatio = invData.ETotalBatChrg / invData.ETotalFromGrid;
                }
                if (invData && invData.ETotalBatDischrg > 0 && invData.ETotalToGrid > 0) {
                    batToGridRatio = invData.ETotalBatDischrg / invData.ETotalToGrid;
                }
                EMonBatChrg[moment(v['YM']).date() - 1] = Math.round(calc.energy(v['EMonFromGrid'], protocol) * gridToBatRatio);
                EMonBatDischrg[moment(v['YM']).date() - 1] = Math.round(calc.energy(v['EMonToGrid'], protocol) * batToGridRatio);
            }
        })
        //Echart坐标legend
        energyOption.legend.data = [t('Solar Production'), t('Battery Charge'), t('Battery Discharge'), t('Export to Grid'), t('Import from Grid'), t('Consumption')]
        //Echart坐标数据
        energyOption.series = [
            {
                name: t('Solar Production'),
                type: 'bar',
                data: EMon
            },
            {
                name: t('Battery Charge'),
                type: 'bar',
                data: EMonBatChrg
            },
            {
                name: t('Battery Discharge'),
                type: 'bar',
                data: EMonBatDischrg
            },
            {
                name: t('Import from Grid'),
                type: 'bar',
                data: EMonFromGrid
            },
            {
                name: t('Export to Grid'),
                type: 'bar',
                data: EMonToGrid
            },
            {
                name: t('Consumption'),
                type: 'bar',
                data: EMonToLoad
            },
        ]

        //渲染数据到页面
        const instance = energyChart.current.getEchartsInstance();
        if (instance) {
            instance.setOption(energyOption, true);
        }

    },[SN, yearlyData]);

    //handle totalData
    useEffect(() => {
        if (!SN || !totalData) return;

        //显示近10年的数据
        const curYear = new Date().getFullYear()
        let days = Array(10).fill(0)
        days.fill(0).forEach((v, i) => {
            days[i] = curYear - 9 + i
        })
        //坐标
        energyOption.xAxis.data = days;
        energyOption.xAxis.name = t('(Year)');
        energyOption.yAxis.name = t('(kWh)');
        
        let EYear = Array(10)
        let EYearBatChrg = Array(10)
        let EYearBatDischrg = Array(10)
        let EYearFromGrid = Array(10)
        let EYearToGrid = Array(10)
        let EYearToLoad = Array(10)

        totalData.forEach(v => {
            EYear[moment(v['Y']).year() - curYear + 9] = calc.energy(v['EYear'], protocol)
            EYearBatChrg[moment(v['Y']).year() - curYear + 9] = calc.energy(v['EYearBatChrg'], protocol)
            EYearBatDischrg[moment(v['Y']).year() - curYear + 9] = calc.energy(v['EYearBatDischrg'], protocol)
            EYearFromGrid[moment(v['Y']).year() - curYear + 9] = calc.energy(v['EYearFromGrid'], protocol)
            EYearToGrid[moment(v['Y']).year() - curYear + 9] = calc.energy(v['EYearToGrid'], protocol)
            EYearToLoad[moment(v['Y']).year() - curYear + 9] = calc.energy(v['EYearLOAD'], protocol)
            //对Sinexcel工商储的电池能量数据的处理
            if (protocol == 'Sinexcel' && (model == 'EINV125H3-B215' || model == 'EINV125H3-NB172')) {
                let batToGridRatio = 1.015, gridToBatRatio = 0.985;
                if (invData && invData.ETotalBatChrg > 0 && invData.ETotalFromGrid > 0) {
                    gridToBatRatio = invData.ETotalBatChrg / invData.ETotalFromGrid;
                }
                if (invData && invData.ETotalBatDischrg > 0 && invData.ETotalToGrid > 0) {
                    batToGridRatio = invData.ETotalBatDischrg / invData.ETotalToGrid;
                }
                EYearBatChrg[moment(v['Y']).date() - 1] = Math.round(calc.energy(v['EYearFromGrid'], protocol) * gridToBatRatio);
                EYearBatDischrg[moment(v['Y']).date() - 1] = Math.round(calc.energy(v['EYearToGrid'], protocol) * batToGridRatio);
            }
        })
        //Echart坐标legend
        energyOption.legend.data = [t('Solar Production'), t('Battery Charge'), t('Battery Discharge'), t('Export to Grid'), t('Import from Grid'), t('Consumption')]
        //Echart数据
        energyOption.series = [
            {
                name: t('Solar Production'),
                type: 'bar',
                data: EYear
            },
            {
                name: t('Battery Charge'),
                type: 'bar',
                data: EYearBatChrg
            },
            {
                name: t('Battery Discharge'),
                type: 'bar',
                data: EYearBatDischrg
            },
            {
                name: t('Import from Grid'),
                type: 'bar',
                data: EYearFromGrid
            },
            {
                name: t('Export to Grid'),
                type: 'bar',
                data: EYearToGrid
            },
            {
                name: t('Consumption'),
                type: 'bar',
                data: EYearToLoad
            },
        ]

        //渲染数据到页面
        const instance = energyChart.current.getEchartsInstance();
        if (instance) {
            instance.setOption(energyOption, true);
        }
        
    },[SN, totalData]);

    const handleInverterWSError = (e) => {
        //
    }

    const handleInverterWSDate = (data) => {
        let od = refInvData.current;
        if (!od) {
            return;
        }
        
        if (data == null || (data.InverterSN == null && data.SerialNumber == null) || (data.SerialNumber != null && !data.PVI)
        || ((data.DTUType == "I01" || data.DTUType == "I02" || data.DTUType == "I03") && data.SessionID != 0xffffffff)) {
            return;
        }

        // console.log(data);

        const invs = {[od.SerialNumber]: od};
        od.Parallels && od.Parallels.forEach(v => {
            (!invs[v.SN]) && (invs[v.SN] = v);
        });

        try {
            const x = protocol == "Senergy" ? data.PVI : JSON.parse(data.Response);
            const InverterSN = data.InverterSN || data.SerialNumber;
            if (invs[InverterSN]) {
                x["CreateTime"] = utils.convertToBeijingTime(new Date());
                x["IsOnline"] = 1;
                Object.assign(invs[InverterSN], x);

                setInvData({...od})

                //
                let y = refDailyData.current ?? [];
                let dt = utils.convertTime(x["CreateTime"], "Asia/Shanghai", timezone)
                if (y && refPowerDate.current == dt.substring(0, 10)) {
                    refDailyData.current = [...y, {...x, "YMDH": dt}];
                    setDailyData(refDailyData.current);
                }
                //
                let yMonthlyData = refMonthlyData.current??[];
                let yYearlyData = refYearlyData.current??[];
                let yTotalData = refTotalData.current??[];
                if (yMonthlyData && refSize.current == "monthly" && refEnergyDate.current.substring(0, 7) == dt.substring(0, 7)) {
                    let z = {
                        "EDay": x["EDay"],
                        "EDayBatChrg": x["EDayBatChrg"],
                        "EDayBatDischrg": x["EDayBatDischrg"],
                        "EDayEPS": x["EDayEPS"],
                        "EDayFromGrid": x["EDayFromGrid"],
                        "EDayLOAD": x["EDayLOAD"],
                        "EDayToGrid": x["EDayToGrid"],
                        "EDayToLoad": x["EDayToLoad"],
                    }
                    let replaced = false;
                    for (let i = 0; i < yMonthlyData.length; i++) {
                        if (yMonthlyData[i].YMD.substring(0, 10) == dt.substring(0, 10)) {
                            yMonthlyData[i] = {...yMonthlyData[i], ...z};
                            setMonthlyData([...yMonthlyData]);
                            replaced = true;
                            break;
                        }
                    }
                    if (!replaced) {
                        x["YMD"] = dt.substring(0, 10)+" 00:00:00";
                        refMonthlyData.current.push(x);
                        setMonthlyData(refMonthlyData.current);
                    }
                }
                if (yYearlyData && refSize.current == "yearly" && refEnergyDate.current.substring(0, 4) == dt.substring(0, 4)) {
                    let z = {
                        "EMon": x["EMon"],
                        "EMonBatChrg": x["EMonBatChrg"],
                        "EMonBatDischrg": x["EMonBatDischrg"],
                        "EMonEPS": x["EMonEPS"],
                        "EMonFromGrid": x["EMonFromGrid"],
                        "EMonLOAD": x["EMonLOAD"],
                        "EMonToGrid": x["EMonToGrid"],
                        "EMonToLoad": x["EMonToLoad"],
                    }
                    let replaced = false;
                    for (let i = 0; i < yYearlyData.length; i++) {
                        if (yYearlyData[i].YM.substring(0, 7) == dt.substring(0, 7)) {
                            yYearlyData[i] = {...yYearlyData[i], ...z};
                            setYearlyData([...yYearlyData]);
                            replaced = true;
                            break;
                        }
                    }
                    if (!replaced) {
                        x["YM"] = dt.substring(0, 7)+"-01 00:00:00";
                        refYearlyData.current.push(x);
                        setYearlyData(refYearlyData.current);
                    }
                }
                if (yTotalData && refSize.current == "all-years") {
                    let z = {
                        "EYear": x["EYear"],
                        "EYearBatChrg": x["EYearBatChrg"],
                        "EYearBatDischrg": x["EYearBatDischrg"],
                        "EYearEPS": x["EYearEPS"],
                        "EYearFromGrid": x["EYearFromGrid"],
                        "EYearLOAD": x["EYearLOAD"],
                        "EYearToGrid": x["EYearToGrid"],
                        "EYearToLoad": x["EYearToLoad"],
                    }
                    let replaced = false;
                    for (let i = 0; i < yTotalData.length; i++) {
                        if (yTotalData[i].Y.substring(0, 4) == dt.substring(0, 4)) {
                            yTotalData[i] = {...yTotalData[i], ...z};
                            setTotalData([...yTotalData]);
                            replaced = true;
                            break;
                        }
                    }
                    if (!replaced) {
                        x["Y"] = dt.substring(0, 4)+"-01-01 00:00:00";
                        refTotalData.current.push(x);
                        setTotalData(refTotalData.current);
                    }
                }
            }
        } catch (e) {
            console.log("[Inverter RT-Monitor]", e);
        }
    }

    const handleBatteryWSError = (e) => {
        //
    }

    const handleBatteryWSDate = (data) => {
        let od = refInvData.current;
        if (!od) {
            return;
        }

        if (!data || (data.MsgID != 0x1001 && (data.MsgID < 0x1060 || data.MsgID > 0x1068))) {
            return;
        }

        // console.log(data);

        const invs = {[od.SerialNumber]: od};
        od.Parallels && od.Parallels.forEach(v => {
            (!invs[v.SN]) && (invs[v.SN] = v);
        });

        let X = JSON.parse(data.X);
        if (X == null) {
            return;
        }

        if (data.MsgID == 0x1001) { // 电池警情
            X["CreateTime"] = utils.convertToBeijingTime(new Date());
            for (let i = 0; i < od.length; i++) {
                if (!od[i].Batteries) {
                    continue;
                }
                for (let j = 0; j < od[i].Batteries.length; j++) {
                    if (od[i].Batteries[j].SN == data.DeviceSN) {
                        let bat = od[i].Batteries[j];
                        if (bat == null) {
                            continue;
                        }
                        if (bat.Alarms == null) {
                            bat.Alarms = X;
                        } else {
                            Object.assign(bat.Alarms, X);
                        }
                    }
                }
            }

            setInvData({...od});
        } else { //逆变器信息
            const ms = {};
            if (data.MsgID == 0x1060) { //逆变器信息
                ms["VAC1Inv"] = X.VoltageA
                ms["IAC1Inv"] = X.CurrentA
                ms["PAC1Inv"] = X.PowerA
                ms["VAC2Inv"] = X.VoltageB
                ms["IAC2Inv"] = X.CurrentB
                ms["PAC2Inv"] = X.PowerB
                ms["VAC3Inv"] = X.VoltageC
                ms["IAC3Inv"] = X.CurrentC
                ms["PAC3Inv"] = X.PowerC
                ms["HzAC1Inv"] = X.HzA
                ms["HzAC2Inv"] = X.HzB
                ms["HzAC3Inv"] = X.HzC
            } else if (data.MsgID == 0x1061) { //PV信息
                ms["VMPPT1"] = X.PV1Voltage
                ms["IMPPT1"] = X.PV1Current
                ms["VMPPT2"] = X.PV2Voltage
                ms["IMPPT2"] = X.PV2Current
                ms["VMPPT3"] = X.PV3Voltage
                ms["IMPPT3"] = X.PV3Current
                ms["VMPPT4"] = X.PV4Voltage
                ms["IMPPT4"] = X.PV4Current
                ms["PMPPT1"] = X.PV1Power
                ms["PMPPT2"] = X.PV2Power
                ms["PMPPT3"] = X.PV3Power
                ms["PMPPT4"] = X.PV4Power
            } else if (data.MsgID == 0x1062) { //电池信息
                ms["VBat"] = X.Voltage
                ms["IBat"] = X.Current
                ms["PBat"] = X.Power
                ms["SOC"] = X.SOC
                ms["BatTemp"] = X.Temp
                ms["BatChargeVoltage"] = X.ChargeVoltage
                ms["BatChargeCurrentLimit"] = X.ChargeCurrentLimit
                ms["BatDischargeCurrentLimit"] = X.DischargeCurrentLimit
                ms["BatCellMaxVoltage"] = X.CellMaxVoltage
                ms["BatCellMinVoltage"] = X.CellMinVoltage
                ms["BatCellMaxTemperature"] = X.CellMaxTemperature
                ms["BatCellMinTemperature"] = X.CellMinTemperature
            } else if (data.MsgID == 0x1063) { //电网信息
                ms["PAC1GRID"] = X.PowerA
                ms["PAC2GRID"] = X.PowerB
                ms["PAC3GRID"] = X.PowerC
                ms["FACGRID"] = X.Hz
                ms["VAC1GRID"] = X.VoltageA
                ms["IAC1GRID"] = X.CurrentA
                ms["VAC2GRID"] = X.VoltageB
                ms["IAC2GRID"] = X.CurrentB
                ms["VAC3GRID"] = X.VoltageC
                ms["IAC3GRID"] = X.CurrentC
            } else if (data.MsgID == 0x1064) { //负载信息
                ms["PAC1LOAD"] = X.PowerA
                ms["PAC2LOAD"] = X.PowerB
                ms["PAC3LOAD"] = X.PowerC
                ms["VAC1LOAD"] = X.VoltageA
                ms["IAC1LOAD"] = X.CurrentA
                ms["VAC2LOAD"] = X.VoltageB
                ms["IAC2LOAD"] = X.CurrentB
                ms["VAC3LOAD"] = X.VoltageC
                ms["IAC3LOAD"] = X.CurrentC
            } else if (data.MsgID == 0x1065) { //Gen信息
                ms["PAC1GEN"] = X.PowerA
                ms["PAC2GEN"] = X.PowerB
                ms["PAC3GEN"] = X.PowerC
                ms["FACGEN"] = X.Hz
                ms["VAC1GEN"] = X.VoltageA
                ms["IAC1GEN"] = X.CurrentA
                ms["VAC2GEN"] = X.VoltageB
                ms["IAC2GEN"] = X.CurrentB
                ms["VAC3GEN"] = X.VoltageC
                ms["IAC3GEN"] = X.CurrentC
            } else if (data.MsgID == 0x1066) { //告警信息
                ms["WarningOrFault01"] = X.ControlWarning1
                ms["WarningOrFault02"] = X.ControlWarning2
                ms["WarningOrFault03"] = X.ControlFault1
                ms["WarningOrFault04"] = X.ControlFault2
                ms["WarningOrFault05"] = X.ControlStatus
                ms["WarningOrFault06"] = X.MonitorWarning1
                ms["WarningOrFault07"] = X.MonitorWarning2
                ms["WarningOrFault08"] = X.MonitorFault1
                ms["WarningOrFault09"] = X.MonitorFault2
                ms["WarningOrFault10"] = X.BMSWarning1
                ms["WarningOrFault11"] = X.BMSWarning2
                ms["WarningOrFault12"] = X.BMSWarning3
                ms["WarningOrFault13"] = X.BMSWarning4
            } else if (data.MsgID == 0x1067) { //统计信息
                ms["EDay"] = X.PVEDay
                ms["EDayToGrid"] = X.GridEDay
                ms["EDayLOAD"] = X.LoadEDay
                ms["EMon"] = X.PVEMonth
                ms["EMonToGrid"] = X.GridEMonth
                ms["EMonLOAD"] = X.LoadEMonth
                ms["EYear"] = X.PVEYear
                ms["EYearToGrid"] = X.GridEYear
                ms["EYearLOAD"] = X.LoadEYear
                ms["ETotal"] = X.PVETotal
                ms["ETotalToGrid"] = X.GridETotal
                ms["ETotalLOAD"] = X.LoadETotal
                ms["EDayFromGrid"] = X.FromGridEDay
                ms["EDayBatChrg"] = X.ChargeEDay
                ms["EDayBatDischrg"] = X.DischargeEDay
                ms["EMonFromGrid"] = X.FromGridEMonth
                ms["EMonBatChrg"] = X.ChargeEMonth
                ms["EMonBatDischrg"] = X.DischargeEMonth
                ms["EYearFromGrid"] = X.FromGridEYear
                ms["EYearBatChrg"] = X.ChargeEYear
                ms["EYearBatDischrg"] = X.DischargeEYear
                ms["ETotalFromGrid"] = X.FromGridETotal
                ms["ETotalBatChrg"] = X.ChargeETotal
                ms["ETotalBatDischrg"] = X.DischargeETotal

            } else if (data.MsgID == 0x1068) { //告警量、状态量 信息
                ms["InverterType"] = X.Type;
                const d = X.Data;
                //WarningOrFault
                if (d != null && d.length > 0) {
                    for (let i = 0; i < d.length && i+2 < d.length; i+=2) {
                        ms[`WarningOrFault${((i/2) + 1).toFixed(0).padStart(2, "0")}`] = d[i]*256 + d[i+1];
                    }
                }
            }

            if (invs[data.DeviceSN]) {
                ms["CreateTime"] = utils.convertToBeijingTime(new Date());
                ms["IsOnline"] = 1;
                Object.assign(invs[data.DeviceSN], ms);
            }

            if (data.MsgID == 0x1067) {
                let yMonthlyData = refMonthlyData.current??[];
                let yYearlyData = refYearlyData.current??[];
                let yTotalData = refTotalData.current??[];
                let dt = utils.convertTime(od["CreateTime"], "Asia/Shanghai", timezone);
                if (yMonthlyData && refSize.current == "monthly" && refEnergyDate.current.substring(0, 7) == dt.substring(0, 7)) {
                    let x = {
                        "EDay": ms["EDay"],
                        "EDayBatChrg": ms["EDayBatChrg"],
                        "EDayBatDischrg": ms["EDayBatDischrg"],
                        "EDayEPS": ms["EDayEPS"],
                        "EDayFromGrid": ms["EDayFromGrid"],
                        "EDayLOAD": ms["EDayLOAD"],
                        "EDayToGrid": ms["EDayToGrid"],
                        "EDayToLoad": ms["EDayToLoad"],
                    }
                    let replaced = false;
                    for (let i = 0; i < yMonthlyData.length; i++) {
                        if (yMonthlyData[i].YMD.substring(0, 10) == dt.substring(0, 10)) {
                            yMonthlyData[i] = {...yMonthlyData[i], ...x};
                            setMonthlyData([...yMonthlyData]);
                            replaced = true;
                            break;
                        }
                    }
                    if (!replaced) {
                        x["YMD"] = dt.substring(0, 10)+" 00:00:00";
                        refMonthlyData.current.push(x);
                        setMonthlyData(refMonthlyData.current);
                    }
                }
                if (yYearlyData && refSize.current == "yearly" && refEnergyDate.current.substring(0, 4) == dt.substring(0, 4)) {
                    let x = {
                        "EMon": ms["EMon"],
                        "EMonBatChrg": ms["EMonBatChrg"],
                        "EMonBatDischrg": ms["EMonBatDischrg"],
                        "EMonEPS": ms["EMonEPS"],
                        "EMonFromGrid": ms["EMonFromGrid"],
                        "EMonLOAD": ms["EMonLOAD"],
                        "EMonToGrid": ms["EMonToGrid"],
                        "EMonToLoad": ms["EMonToLoad"],
                    }
                    let replaced = false;
                    for (let i = 0; i < yYearlyData.length; i++) {
                        if (yYearlyData[i].YM.substring(0, 7) == dt.substring(0, 7)) {
                            yYearlyData[i] = {...yYearlyData[i], ...x};
                            setYearlyData([...yYearlyData]);
                            replaced = true;
                            break;
                        }
                    }
                    if (!replaced) {
                        x["YM"] = dt.substring(0, 7)+"-01 00:00:00";
                        refYearlyData.current.push(x);
                        setYearlyData(refYearlyData.current);
                    }
                }
                if (yTotalData && refSize.current == "all-years") {
                    let x = {
                        "EYear": ms["EYear"],
                        "EYearBatChrg": ms["EYearBatChrg"],
                        "EYearBatDischrg": ms["EYearBatDischrg"],
                        "EYearEPS": ms["EYearEPS"],
                        "EYearFromGrid": ms["EYearFromGrid"],
                        "EYearLOAD": ms["EYearLOAD"],
                        "EYearToGrid": ms["EYearToGrid"],
                        "EYearToLoad": ms["EYearToLoad"],
                    }
                    let replaced = false;
                    for (let i = 0; i < yTotalData.length; i++) {
                        if (yTotalData[i].Y.substring(0, 4) == dt.substring(0, 4)) {
                            yTotalData[i] = {...yTotalData[i], ...x};
                            setTotalData([...yTotalData]);
                            replaced = true;
                            break;
                        }
                    }
                    if (!replaced) {
                        x["Y"] = dt.substring(0, 4)+"-01-01 00:00:00";
                        refTotalData.current.push(x);
                        setTotalData(refTotalData.current);
                    }
                }
            } else {
                setInvData({...od});
                
                let y = refDailyData.current ?? [];
                let x = {...od}
                let dt = utils.convertTime(x["CreateTime"], "Asia/Shanghai", timezone)
                if (y && refPowerDate.current == dt.substring(0, 10)) {
                    x["CreateTime"] = dt;
                    x["IsOnline"] = 1;
                    refDailyData.current = [...y, x];
                    setDailyData(refDailyData.current);
                }
            }
        }
        
    }

    const handleClickSolar = () => {
        setSolarIndex((solarIndex + 1) % 3)
    }

    const handleClickBattery = () => {
        setBatteryIndex((batteryIndex + 1) % 2)
    }

    const handleClickGrid = () => {
        setGridIndex((gridIndex + 1) % 2)
    }

    //计算solar面板的百分比
    const calSolarRatio = (x, y) => {
        if (isNaN(x) || isNaN(y) || y == 0) {
            return 0
        }
        let r = 100 * x / y;
        if (r % 1 != 0) {
            r = r.toFixed(1)
        }
        return r
    }

    const hex2Array = (hex) => {
        var arr = new Uint8Array(hex.match(/[\da-f]{2}/gi).map((h)=>parseInt(h, 16)));
        return Array.prototype.slice.call(new Uint8Array(arr.buffer )); 
    }

    const Array2hex = (arr) => {
        return arr.map((v) => v.toString(16).padStart(2, "0")).join("");
    }

    const doSmartSwitch =  async (v) => {
        let bs = [0x01, 0x10, 0xf4, 0x00, 0x00, 0x01, 0x02, (v>>8)&0xff, v&0xff];
        var str = CRC.ToModbusCRC16(bs);
        bs = bs.concat(hex2Array(str));

        setLoading(true);
        try {
            const resp = await http.postJSON("integrated-inverter-v2/setting/prior/request", {
                SerialNumber: SN,
                RW: "R",
                RequestAndResponses: [{
                    Request: bs,
                }],
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                console.log("[Setting]", e);
                return null;
            });
            
            if (resp.data.SerialNumber != SN) {
                setTip({ open: true, severity: "error", msg: t("SerialNumber not match") });
                return;
            }

            var rs = resp.data.RequestAndResponses;
            if (rs != null && rs.length > 0) {
                let r = rs[0].Response;
                if (r == null || r.length < 5 || r[1] != 0x10 || (r[2]<<8)+r[3] != 0xf400) {
                    setTip({ open: true, severity: "error", msg: t("Action error") });
                    return;
                }
            } else {
                setTip({ open: true, severity: "error", msg: t("Action error") });
                return;
            }

            setTip({ open: true, severity: 'success', msg: t("Command executed successfully") });

            setSmartPlugStatus(v);

        } catch (e) {
            console.log("[RealtimeMonitor]", e);
            setTip({ open: true, severity: "error", msg: t("Smart Plug error") });
        } finally {
            setLoading(false);
        }
    }

    const doGetSmartSwitch =  async () => {
        let bs = [0x01, 0x3, 0xf4, 0x00, 0x00, 0x01];
        var str = CRC.ToModbusCRC16(bs);
        bs = bs.concat(hex2Array(str));

        setLoading(true);
        try {
            const resp = await http.postJSON("integrated-inverter-v2/setting/prior/request", {
                SerialNumber: SN,
                RW: "R",
                RequestAndResponses: [{
                    Request: bs,
                }],
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                console.log("[Setting]", e);
                return null;
            });
            
            if (resp.data.SerialNumber != SN) {
                setTip({ open: true, severity: "error", msg: t("SerialNumber not match") });
                return;
            }

            var rs = resp.data.RequestAndResponses;
            if (rs != null && rs.length > 0) {
                let r = rs[0].Response;
                if (r == null || r.length < 5 || r[1] != 0x03) {
                    setTip({ open: true, severity: "error", msg: t("Action error") });
                    return;
                }

                let v = (r[3]<<8)+r[4];
                setSmartPlugStatus(v);
            } else {
                setTip({ open: true, severity: "error", msg: t("Action error") });
                return;
            }

            setTip({ open: true, severity: 'success', msg: t("Command executed successfully") });

        } catch (e) {
            console.log("[RealtimeMonitor]", e);
            setTip({ open: true, severity: "error", msg: t("Smart Plug error") });
        } finally {
            setLoading(false);
        }
    }

    const showBatteryInfo = () => { 
        let mdl = Modal.info({
            maskClosable: true,
            width: "1000px",
            icon: null,
            title: (<div style={{display: "flex", justifyContent: "space-between"}}>
                <Button type="primary">{t("Batteries Data")}</Button>
                <Button type="dashed" danger onClick={() => {mdl.destroy(); showBatteryAlarms()}}>{t("Inverter/Battery Alarms")}</Button>
            </div>),
            content: (<Table 
                pagination={false}
                columns={[
                    { title: t("Inverter SN"), dataIndex: "SN",  align: "right",render: (v,r) => {
                        return `${v}`;
                    } },
                    { title: t("Mounted Batteries"), dataIndex: "Batteries",  align: "left",render: (v,r) => {

                        return v&&(v.map((item,index) => {
                            return (<><Button onClick={()=>{
                                props.handleConverToMonitor(item.SN, item.SN);
                                props.onNavigate('Monitor', () => {
                                    return <Monitor />
                                }, "Inverter");
                                mdl.destroy();
                            }}>{item.SN}</Button><br/></>)
                        }));
                    } },
                    { title: t("DataTime"), dataIndex: "CreateTime",  align: "right" },
                    { title: t("SOC")+"(%)", dataIndex: "SOC",  align: "right", render: (v,r) => {
                        if (v == null) {
                            return "";
                        }
                        return calc.soc(v, protocol)
                    }},
                    { title: t("PBattery")+"(kW)", dataIndex: "PBat",  align: "right", render: (v,r) => {
                        if (v == null) {
                            return "";
                        }
                        return calc.power(v, protocol, ParallelInfo.IsParallel && !ParallelInfo.ParallelSN);
                    }},
                    { title: t("VBattery")+"(V)", dataIndex: "VBat",  align: "right", render: (v,r) => {
                        return calc.voltage(v, protocol);
                    }},
                ]}
                dataSource={refInverters.current??[]}
            />),
            onOk() {
            },
        });
    }

    const showBatteryAlarms = () => {
        let mdl = Modal.info({
            maskClosable: true,
            width: "800px",
            icon: null,
            title: (<div style={{display: "flex", justifyContent: "space-between"}}>
                <Button type="primary" danger>{t("Inverter/Battery Alarms")}</Button>
                <Button type="dashed" onClick={() => {mdl.destroy(); showBatteryInfo()}}>{t("Batteries Data")}</Button>
            </div>),
            content: (<Table 
                pagination={false}
                columns={[
                    { title: t("DataTime"), dataIndex: "CreateTime",  align: "right" },
                    { title: t("From"), dataIndex: "From",  align: "left",render: (v,r) => {
                        return `[${v}] ${r.SN}`;
                    }},
                    { title: t("Name"), dataIndex: "Name",  align: "left", render: (v,r) => {
                        return `${v}${r.From=="Battery" ? "(L"+r.Level.toString()+")" : ""}`;
                    } },
                ]}
                dataSource={batteryAlarmsFromInverters.concat(batteryAlarms)}
            />),
            onOk() {
            },
        });
    }
    
    const showAllAlarms = () => {
        Modal.info({
            maskClosable: true,
            width: "800px",
            icon: null,
            title: t("Inverter/Battery Alarms"),
            content: (<Table
                pagination={false}
                columns={[
                    { title: t("DataTime"), dataIndex: "CreateTime", align: "right" },
                    {
                        title: t("From"), dataIndex: "From", align: "left", render: (v, r) => {
                            return `[${v}] ${r.SN}`;
                        }
                    },
                    {
                        title: t("Name"), dataIndex: "Name", align: "left", render: (v, r) => {
                            return `${v}${r.From == "Battery" ? "(L" + r.Level.toString() + ")" : ""}`;
                        }
                    },
                ]}
                dataSource={inverterAlarms.concat(batteryAlarms)}
            />),
            onOk() {
            },
        });
    }


    //图标url
    const pvImgUrl = "images/inverter/solar.png";
    const gridImgUrl = "images/inverter/grid.png";
    const statusImgUrl = "images/inverter/" + (invData && invData.IsOnline == 1 ?
        invData.IsAlarm ? "flow_notice.png" : "flow_normal.png" :
        "flow_offline.png")
    const epsImgUrl = "images/inverter/eps.png";
    const loadImgUrl = "images/inverter/load.png";
    // const invImgUrl = "images/inverter/flow_" + 
    //     (protocol=='Thinkpower' ? 'tp_inv_' : 'sen_inv_') + 
    //     (invData&&invData.Inverters ? invData.Inverters.length : 1) + 
    //     '.png';
    const invImgUrl = "images/inverter/" +
        (model == 'Uhome-INVT-3P-4~12kW' ? "H3EHB-" : 'L1EHB-') +
        (invData && invData.Inverters && invData.Inverters.length > 0 ? invData.Inverters.length : 1) +
        '.png';
    const soc = calc.soc(invData && invData.SOC, protocol);
    let soc_level = Math.round(soc / 20);
    if (soc_level > 5) {
        soc_level = 5;
    } else if (soc_level < 0) {
        soc_level = 0;
    }
    const batImgUrl = "images/inverter/flow_bat_" +
        (invData && (batteryAlarmsFromInverters.length>0||batteryAlarms.length>0) ? 'alarm_' : '') +
        (invData && invData.Batteries ? invData.Batteries.length : 1) + "_" +
        (invData && soc_level ? soc_level : 0) +
        '.png';

    //处理数据
    let Ppv1 = 0, Ppv2 = 0, Ppv3 = 0, Ppv4 = 0,
        Vpv1 = 0, Vpv2 = 0, Vpv3 = 0, Vpv4 = 0,
        Pbat = 0, Vbat = 0, Ibat = 0,
        Pgrid1 = 0, Pgrid2 = 0, Pgrid3 = 0, Vgrid1 = 0, Vgrid2 = 0, Vgrid3 = 0, Fgrid = 0,
        Pload1 = 0, Pload2 = 0, Pload3 = 0,
        Peps1 = 0, Peps2 = 0, Peps3 = 0;
    let EDay = invData && invData.EDay,
        EDayToGrid = invData && invData.EDayToGrid,
        EDayFromGrid = invData && invData.EDayFromGrid,
        EDayBatChrg = invData && invData.EDayBatChrg,
        EDayBatDischrg = invData && invData.EDayBatDischrg,
        EDayLOAD = invData && invData.EDayLOAD,
        ETotal = invData && invData.ETotal,
        ETotalToGrid = invData && invData.ETotalToGrid,
        ETotalFromGrid = invData && invData.ETotalFromGrid,
        ETotalBatChrg = invData && invData.ETotalBatChrg,
        ETotalBatDischrg = invData && invData.ETotalBatDischrg,
        ETotalLOAD = invData && invData.ETotalLOAD;


    let latestTime = invData && invData.DataTime; //多个并机逆变器的最新时间
    invData && invData.Inverters && invData.Inverters.forEach(inv => {
        if (inv.CreateTime > latestTime) latestTime = inv.CreateTime;
    })

    if (invData) {
        if (protocol === 'Senergy') {
            const inverters = invData.Inverters;
            Vpv1 = invData.VMPPT1;
            Vbat = invData.VBat;
            Ibat = invData.IBat;
            Vgrid1 = invData.VAC1GRID;
            Fgrid = invData.FACGRID;
            if (inverters && inverters.length > 1 && new Date(latestTime).getTime() - new Date(invData.DataTime).getTime() < 1000 * 60 * 8) { //多个逆变器并机, 只有数据时间相差8分钟内的才计算
                inverters.forEach(inv => {
                    const interval = new Date(latestTime).getTime() - new Date(inv.CreateTime).getTime();
                    if (interval < 1000 * 60 * 8) { //间隔时间在8分钟内视为同一时刻的数据
                        Ppv1 = inv.PDC != null && (Ppv1 || 0) + (inv.PDC || 0);
                        Pbat = inv.PBat != null && (Pbat || 0) + (inv.PBat || 0);
                        Pgrid1 = inv.PAC1GRID != null && (Pgrid1 || 0) + (inv.PAC1GRID || 0);
                        Pgrid2 = inv.PAC2GRID != null && (Pgrid2 || 0) + (inv.PAC2GRID || 0);
                        Pgrid3 = inv.PAC3GRID != null && (Pgrid3 || 0) + (inv.PAC3GRID || 0);
                        Pload1 = inv.PAC1LOAD != null && (Pload1 || 0) + (inv.PAC1LOAD || 0);
                        Pload2 = inv.PAC2LOAD != null && (Pload2 || 0) + (inv.PAC2LOAD || 0);
                        Pload3 = inv.PAC3LOAD != null && (Pload3 || 0) + (inv.PAC3LOAD || 0);
                        Peps1 = inv.PAC1EPS != null && (Peps1 || 0) + (inv.PAC1EPS || 0);
                    }
                })
            } else { //单个逆变器
                Ppv1 = invData.PDC;
                Pbat = invData.PBat;
                Pgrid1 = invData.PAC1GRID;
                Pload1 = invData.PAC1LOAD;
                Peps1 = invData.PAC1EPS;
            }
        } else if (protocol === 'Thinkpower' || protocol === 'Megarevo' || protocol === 'Sinexcel' || protocol === 'Megarevo-CESS' || protocol === 'Sungery') {
            if (protocol === 'Sungery' && ParallelInfo.IsParallel) {  //阳台经济的并机
                Vpv1 = invData.VMPPT1;
                Vpv2 = invData.VMPPT2;
                Vpv3 = invData.VMPPT3;
                Vpv4 = invData.VMPPT4;
                Vbat = invData.VBat;
                Ibat = invData.IBat;
                Vgrid1 = invData.VAC1GRID;
                Vgrid2 = invData.VAC2GRID;
                Vgrid3 = invData.VAC3GRID;
                Fgrid = invData.FACGRID;
                if (!ParallelInfo.ParallelSN) { //总并机
                    Pbat = invData.ParallelBattSumPower;
                    Pgrid1 = invData.ParallelLineSumPowerW_A;
                    Pgrid2 = invData.ParallelLineSumPowerW_B;
                    Pgrid3 = invData.ParallelLineSumPowerW_C;
                    Pload1 = invData.ParallelNormalSumLoadW_A;
                    Pload2 = invData.ParallelNormalSumLoadW_B;
                    Pload3 = invData.ParallelNormalSumLoadW_C;
                    Peps1 = invData.ParallelBackUpSumOutW_A;
                    Peps2 = invData.ParallelBackUpSumOutW_B;
                    Peps3 = invData.ParallelBackUpSumOutW_C;
                    EDay = 0;
                    EDayToGrid = 0;
                    EDayFromGrid = 0;
                    EDayBatChrg = 0;
                    EDayBatDischrg = 0;
                    EDayLOAD = 0;
                    ETotal = 0;
                    ETotalToGrid = 0;
                    ETotalFromGrid = 0;
                    ETotalBatChrg = 0;
                    ETotalBatDischrg = 0;
                    ETotalLOAD = 0;
                    //计算光伏总功率, 以及总能量
                    invData.Parallels.forEach(parallel => {
                        Ppv1 += (parallel.PMPPT1 || 0);
                        Ppv2 += (parallel.PMPPT2 || 0);
                        EDay += (parallel.EDay || 0);
                        EDayToGrid += (parallel.EDayToGrid || 0);
                        EDayFromGrid += (parallel.EDayFromGrid || 0);
                        EDayBatChrg += (parallel.EDayBatChrg || 0);
                        EDayBatDischrg += (parallel.EDayBatDischrg || 0);
                        EDayLOAD += (parallel.EDayLOAD || 0);
                        ETotal += (parallel.ETotal || 0);
                        ETotalToGrid += (parallel.ETotalToGrid || 0);
                        ETotalFromGrid += (parallel.ETotalFromGrid || 0);
                        ETotalBatChrg += (parallel.ETotalBatChrg || 0);
                        ETotalBatDischrg += (parallel.ETotalBatDischrg || 0);
                        ETotalLOAD += (parallel.ETotalLOAD || 0);
                    })
                    //三相并机的电网电压分别显示每个分机的对应相
                    const maxParaMode = invData.Parallels.length > 1 ? invData.Parallels[invData.Parallels.length - 1].ParaMode : 0;
                    if (maxParaMode >= 5) { //三项并机
                        const phaseAInv = invData.Parallels.filter(parallel => parallel.ParaMode === 5);
                        const phaseBInv = invData.Parallels.filter(parallel => parallel.ParaMode === 6);
                        const phaseCInv = invData.Parallels.filter(parallel => parallel.ParaMode === 7);
                        Vgrid1 = phaseAInv.length > 0 && phaseAInv[0].VAC1Line;
                        Vgrid2 = phaseBInv.length > 0 && phaseBInv[0].VAC1Line;
                        Vgrid3 = phaseCInv.length > 0 && phaseCInv[0].VAC1Line;
                    }
                    //2025.6.19 1：市电输出时，固定功率馈网发电, 且仅并功率
                    if (invData.OnGirdSet == 1 && invData.ParaMode < 5) {
                        invData.Parallels.forEach(parallel => {
                            Pgrid1 += (parallel.PAC1Line || 0);
                            Pgrid2 += (parallel.PAC2Line || 0);
                            Pgrid3 += (parallel.PAC3Line || 0);
                        });
                    }
                } else { //并机里的分机
                    Ppv1 = invData.PMPPT1;
                    Ppv2 = invData.PMPPT2;
                    Ppv3 = invData.PMPPT3;
                    Ppv4 = invData.PMPPT4;
                    Pbat = invData.PBat;
                    Pgrid1 = invData.PAC1GRID;
                    Pgrid2 = invData.PAC2GRID;
                    Pgrid3 = invData.PAC3GRID;
                    Pload1 = invData.ParallelNormalSumLoadW_A;  //并机情形下的分机也显示常规总负载
                    Pload2 = invData.ParallelNormalSumLoadW_B;
                    Pload3 = invData.ParallelNormalSumLoadW_C;
                    Peps1 = invData.PAC1EPS;
                    Peps2 = invData.PAC2EPS;
                    Peps3 = invData.PAC3EPS;
                    //2025.6.19 1：市电输出时，固定功率馈网发电
                    if (invData.OnGirdSet == 1 && invData.ParaMode < 5) {
                        Pgrid1 = invData.PAC1Line;
                        Pgrid2 = invData.PAC2Line;
                        Pgrid3 = invData.PAC3Line;
                    }
                }
            } else {
                const inverters = invData.Inverters;
                Vpv1 = invData.VMPPT1;
                Vpv2 = invData.VMPPT2;
                Vpv3 = invData.VMPPT3;
                Vpv4 = invData.VMPPT4;
                Vbat = invData.VBat;
                Ibat = invData.IBat;
                Vgrid1 = invData.VAC1GRID;
                Vgrid2 = invData.VAC2GRID;
                Vgrid3 = invData.VAC3GRID;
                Fgrid = invData.FACGRID;
                if (inverters && inverters.length > 1 && new Date(latestTime).getTime() - new Date(invData.CreateTime).getTime() < 1000 * 60 * 8) { //多个逆变器并机, 通过inverter_device表
                    inverters.forEach(inv => {
                        const interval = new Date(latestTime).getTime() - new Date(inv.CreateTime).getTime();
                        if (interval < 1000 * 60 * 8) { //间隔时间在8分钟内视为同一时刻的数据
                            Ppv1 = inv.PMPPT1 != null && (Ppv1 || 0) + (inv.PMPPT1 || 0);
                            Ppv2 = inv.PMPPT2 != null && (Ppv2 || 0) + (inv.PMPPT2 || 0);
                            Ppv3 = inv.PMPPT3 != null && (Ppv3 || 0) + (inv.PMPPT3 || 0);
                            Ppv4 = inv.PMPPT4 != null && (Ppv4 || 0) + (inv.PMPPT4 || 0);
                            Pbat = inv.PBAT != null && (Pbat || 0) + (inv.PBAT || 0);
                            //2025.6.19 1：Sungery 市电输出时，固定功率馈网发电
                            if (invData.OnGirdSet == 1 && invData.ParaMode < 5) {
                                Pgrid1 = inv.PAC1Line != null && (Pgrid1 || 0) + (inv.PAC1Line || 0);
                                Pgrid2 = inv.PAC2Line != null && (Pgrid2 || 0) + (inv.PAC2Line || 0);
                                Pgrid3 = inv.PAC3Line != null && (Pgrid3 || 0) + (inv.PAC3Line || 0);
                            } else {
                                Pgrid1 = inv.PAC1GRID != null && (Pgrid1 || 0) + (inv.PAC1GRID || 0);
                                Pgrid2 = inv.PAC2GRID != null && (Pgrid2 || 0) + (inv.PAC2GRID || 0);
                                Pgrid3 = inv.PAC3GRID != null && (Pgrid3 || 0) + (inv.PAC3GRID || 0);
                            }
                            Pload1 = inv.PAC1LOAD != null && (Pload1 || 0) + (inv.PAC1LOAD || 0);
                            Pload2 = inv.PAC2LOAD != null && (Pload2 || 0) + (inv.PAC2LOAD || 0);
                            Pload3 = inv.PAC3LOAD != null && (Pload3 || 0) + (inv.PAC3LOAD || 0);
                            Peps1 = inv.PAC1EPS != null && (Peps1 || 0) + (inv.PAC1EPS || 0);
                            Peps2 = inv.PAC2EPS != null && (Peps2 || 0) + (inv.PAC2EPS || 0);
                            Peps3 = inv.PAC3EPS != null && (Peps3 || 0) + (inv.PAC3EPS || 0);
                        }
                    })
                } else { //单个逆变器
                    Ppv1 = invData.PMPPT1;
                    Ppv2 = invData.PMPPT2;
                    Ppv3 = invData.PMPPT3;
                    Ppv4 = invData.PMPPT4;
                    Pbat = invData.PBat;
                    Pgrid1 = invData.PAC1GRID;
                    Pgrid2 = invData.PAC2GRID;
                    Pgrid3 = invData.PAC3GRID;
                    Pload1 = invData.PAC1LOAD;
                    Pload2 = invData.PAC2LOAD;
                    Pload3 = invData.PAC3LOAD;
                    Peps1 = invData.PAC1EPS;
                    Peps2 = invData.PAC2EPS;
                    Peps3 = invData.PAC3EPS;
                    //2025.6.19 1：Sungery 市电输出时，固定功率馈网发电
                    if (invData.OnGirdSet == 1 && invData.ParaMode < 5) {
                        Pgrid1 = invData.PAC1Line;
                        Pgrid2 = invData.PAC2Line;
                        Pgrid3 = invData.PAC3Line;
                    }
                }
            }
        }
    }

    

    //带时区的实时数据的时间
    let CreateTime = invData ? invData.CreateTime : null,
        gmtOffset = invData ? invData.GmtOffset : null;
    if (CreateTime && gmtOffset) {
        // let n = parseInt(gmtOffset);
        // var tz = "UTC+";
        // if (n < 0) {
        //     tz = "UTC-";
        //     n = Math.abs(n);
        // }
        // tz += Math.floor(n / 3600).toString().padStart(2, "0") + ":" + Math.floor((n % 3600) / 60).toString().padStart(2, "0")
        CreateTime = utils.convertToLocalTime(CreateTime, "Asia/Shanghai"); //+ '(' + tz + ')';
    }

    //流图的方向   
    /*
    * Senergy: PBat(> 0: 放电, < 0: 充电), PGrid(> 0: 购电, < 0: 馈网)
    * 以下与Senergy比较, √同, ×反
    * Megarevo[-CESS]: Bat ×, Grid ×
    * Thinkpower: Bat √, Grid ×
    * Sinexcel: Bat ×, Grid √
    * Sungery: Bat √, Grid √
    * 注: Senergy单相, Thinkpower与Megarevo三相
    * 注: Charge/Discharge: 充电/放电, Export/Import: 馈网/购电
    */
    let PVToInv = false,        //PV->Inv
        InvToBat = false,       //Inv->Bat
        BatToInv = false,       //Bat->Inv
        InvToEPS = false,       //Inv->Eps
        EPSToInv = false,       //Eps->Inv
        FromGrid = false,       //购电
        ToGrid = false,         //售电
        FromInv = false,        //Inv -> (Grid / Load)
        ToInv = false,          //(Grid) -> Inv
        ToLoad = false;         //Load有功率
    //判断流向
    PVToInv = protocol === 'Senergy' ?
        Ppv1 > 0 :
        (Ppv1 || 0) + (Ppv2 || 0) + (Ppv3 || 0) + (Ppv4 || 0) > 0
    Ibat = calc.current(Ibat, protocol);  //处理Sungery电池功率的方向
    BatToInv = protocol === 'Senergy' || protocol === 'Thinkpower' || protocol === 'Sungery' ?
        Pbat > 0 :
        Pbat < 0;
    InvToBat = protocol === 'Senergy' || protocol === 'Thinkpower' || protocol === 'Sungery' ?
        Pbat < 0 :
        Pbat > 0;
    InvToEPS = Peps1 + Peps2 + Peps3 > 0;
    EPSToInv = Peps1 + Peps2 + Peps3 < 0;
    ToLoad = Pload1 + Pload2 + Pload3 > 0;
    FromGrid = protocol === 'Senergy' || protocol === 'Sinexcel' || protocol === 'Sungery' ?
        Pgrid1 + Pgrid2 + Pgrid3 > 0 :
        Pgrid1 + Pgrid2 + Pgrid3 < 0;
    ToGrid = protocol === 'Senergy' || protocol === 'Sinexcel' || protocol === 'Sungery' ?
        Pgrid1 + Pgrid2 + Pgrid3 < 0 :
        Pgrid1 + Pgrid2 + Pgrid3 > 0;
    FromInv = ToGrid || ((PVToInv || BatToInv) && Math.abs(Pgrid1 + Pgrid2 + Pgrid3) < Pload1 + Pload2 + Pload3);
    ToInv = FromGrid && Math.abs(Pgrid1 + Pgrid2 + Pgrid3) > Pload1 + Pload2 + Pload3;

    if (hasSmartPlug == true && invData) { //有智能插座
        Pgrid1 = (parseInt(invData.PAC1LOAD) ??0) - (parseInt(invData.PAC1Inv)??0) + (parseInt(invData.PAC1EPS)??0);
        FromGrid = Pgrid1 > 0;
        ToGrid = Pgrid1 < 0;
        FromInv = (parseInt(invData.PAC1Inv)??0) > 0;
        ToInv = (parseInt(invData.PAC1Inv)??0) < 0;
    }

    //2025.3.25
    let chargeLimit = null;
    let dischargeLimit = null
    if (invData) {
        chargeLimit = invData.BatChargeCurrentLimit;
        dischargeLimit = invData.BatDischargeCurrentLimit;
        if (chargeLimit == undefined) {
            chargeLimit = null;
        } else {
            chargeLimit = calc.current(chargeLimit, protocol);
        }
        if (dischargeLimit == undefined) {
            dischargeLimit = null;
        } else {
            dischargeLimit = calc.current(dischargeLimit, protocol);
        }
    }
    if (protocol == "Sinexcel" || protocol == "Senergy") {
        chargeLimit = null;
        dischargeLimit = null;
    }

    //inv系统流图
    const bms_sys_flow = (
        <div className="flow-content">

            {/* 流动的箭头 */}
            <img src="images/inverter/flow_down_1.gif" style={{ top: '80px', left: '315px', display: PVToInv ? 'block' : 'none' }} /> {/* pv->inv */}
            <img src="images/inverter/flow_down_1.gif" style={{ top: '268px', left: '315px', display: InvToEPS ? 'block' : 'none' }} /> {/* inv->eps */}
            <img src="images/inverter/flow_up.gif" style={{ top: '272px', left: '315px', display: EPSToInv ? 'block' : 'none' }} /> {/* eps->inv */}
            <img src="images/inverter/flow_right_2.gif" style={{ top: '206px', left: '106px', display: BatToInv ? 'block' : 'none' }} />  {/* bat->inv */}
            <img src="images/inverter/flow_left_2.gif" style={{ top: '206px', left: '106px', display: InvToBat ? 'block' : 'none' }} />  {/* inv->bat */}
            <img src="images/inverter/flow_down_2.gif" style={{ top: '214px', left: '584px', display: (ToLoad && (FromGrid || FromInv)) ? 'block' : 'none' }} /> {/* ->Load */}
            <img src="images/inverter/flow_left_4.gif" style={{ top: '206px', left: '378px', display: FromGrid && ToInv ? 'block' : 'none' }} /> {/* Grid->Inv */}
            <img src="images/inverter/flow_right_4.gif" style={{ top: '206px', left: '380px', display: FromInv && ToGrid ? 'block' : 'none' }} /> {/* inv->grid */}
            <img src="images/inverter/flow_left_1.gif" style={{ top: '206px', left: '596px', display: FromGrid && ToLoad && !ToInv ? 'block' : 'none' }} /> {/* Grid->Load not to Inv */}
            <img src="images/inverter/flow_right_3.gif" style={{ top: '206px', left: '380px', display: FromInv && ToLoad && !ToGrid ? 'block' : 'none' }} /> {/* Inv->Load not to Grid */}

            {/* 图标 */}
            <img src={pvImgUrl} alt="" width="84" height="84" style={{ top: '-9px', left: '288px' }} />
            {/* <img src={statusImgUrl} alt="" height="32" style={{ top: '12px', left: '700px', }} /> */}
            {inverterAlarms.length>0||batteryAlarms.length>0 ? <Button onClick={showAllAlarms} type='primary' shape='round' danger style={{
                position: "absolute",
                left: "700px",
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)'
            }}>{t("System Alarms")}</Button>:null}
            <svg width="24" height="24" style={{ position: 'absolute', top: '50px', left: '700px' }}>
                <circle cx="12" cy="12" r="11" fill={invData && invData.IsOnline == 1 ? ((inverterAlarms.length>0||batteryAlarms.length>0) ? 'red' : 'limegreen') : '#aaa'} />
            </svg>
            <div style={{
                position: 'absolute',
                top: '46px',
                left: '730px',
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
            }}>
                <div>{CreateTime}</div>
                <Button icon={<ReloadOutlined />} style={{marginLeft: "5px" }} onClick={() => setRefresh(!refresh)} />
            </div>
            <img src={batImgUrl} alt="" width="84" height="84" style={{ top: '172px', left: '40px', cursor: invData ? 'pointer' : null }} onClick={() => {
                if (!invData) return;
                if (batteryAlarmsFromInverters.length > 0 || batteryAlarms.length > 0) {
                    showBatteryAlarms();
                } else {
                    showBatteryInfo();
                }
            }} />
            <img src={invImgUrl} alt="" width="112" style={{ top: '162px', left: '272px', cursor: invData ? 'pointer' : null }} />
            <img src={gridImgUrl} alt="" width="84" height="84" style={{ top: '172px', left: '720px' }} />
            <img src={epsImgUrl} alt="" width="84" height="84" style={{ bottom: '15px', left: '288px' }} />
            <img src={loadImgUrl} alt="" width="84" height="84" style={{ bottom: '20px', left: '550px' }} />

            {/* PV数据 */}
            <div style={{
                width: '360px', top: protocol === 'Senergy' ? '12px' :
                    protocol === 'Sungery' ? '0' : '-25px', left: '386px'
            }}>
                <div>
                    <span style={{ marginRight: '50px' }}>{t('PV1')}</span>
                    <span style={{ marginRight: '50px' }}>{calc.power(Ppv1, protocol, ParallelInfo.IsParallel && !ParallelInfo.ParallelSN, "ppv")} {t('W')}</span>
                    <span>{calc.voltage(Vpv1, protocol)} {t('V')}</span>
                </div>
                <div style={{ display: protocol === 'Senergy' ? 'none' : 'block' }}>
                    <span style={{ marginRight: '50px' }}>{t('PV2')}</span>
                    <span style={{ marginRight: '50px' }}>{calc.power(Ppv2, protocol, ParallelInfo.IsParallel && !ParallelInfo.ParallelSN)} {t('W')}</span>
                    <span>{calc.voltage(Vpv2, protocol)} {t('V')}</span>
                </div>
                <div style={{ display: protocol === 'Senergy' || protocol === 'Sungery' ? 'none' : 'block' }}>
                    <span style={{ marginRight: '50px' }}>{t('PV3')}</span>
                    <span style={{ marginRight: '50px' }}>{calc.power(Ppv3, protocol)} {t('W')}</span>
                    <span>{calc.voltage(Vpv3, protocol)} {t('V')}</span>
                </div>
                <div style={{ display: protocol === 'Senergy' || protocol === 'Sungery' ? 'none' : 'block' }}>
                    <span style={{ marginRight: '50px' }}>{t('PV4')}</span>
                    <span style={{ marginRight: '50px' }}>{calc.power(Ppv4, protocol)} {t('W')}</span>
                    <span>{calc.voltage(Vpv4, protocol)} {t('V')}</span>
                </div>
            </div>
            {/* 电池数据 */}
            <div style={{ top: '172px', marginLeft: '-50px' }}>
                <div>{calc.power(Pbat, protocol, ParallelInfo.IsParallel && !ParallelInfo.ParallelSN)} {t('W')}</div>
                <div>{soc}%</div>
                <div>{calc.voltage(Vbat, protocol)} {t('Vdc')}</div>
            </div>
            <div style={{ top: '270px', left: '40px', display: "flex", flexDirection: "column", fontSize: "14px" }}>
                {chargeLimit==null ? null : (<div>
                    <span>{t('Charge Limit')}: </span>
                    <span style={{ fontWeight: 'bold' }}>{chargeLimit} </span>
                    <span>A</span>
                </div>)}
                {dischargeLimit==null ? null : (<div>
                    <span>{t('Discharge Limit')}: </span>
                    <span style={{ fontWeight: 'bold' }}>{dischargeLimit} </span>
                    <span>A</span>
                </div>)}
                
            </div>
            {/* Grid数据 */}
            {/* 若为Senergy且电网B相或C相功率不为0, 则视为一相并为三相, 按三相显示 */}
            {
                protocol === 'Thinkpower' || protocol === 'Megarevo' || protocol === 'Sinexcel' || protocol === 'Megarevo-CESS' || protocol === 'Sungery' ||
                    (protocol === 'Senergy' && Pgrid2 != null && Pgrid2 != 0) ||
                    (protocol === 'Senergy' && Pgrid3 != null && Pgrid3 != 0) ?
                    (
                        <div style={{ top: '160px', left: '805px' }}>
                            <div>
                                <span style={{ marginRight: '20px' }}>{calc.power(Pgrid1, protocol, ParallelInfo.IsParallel && !ParallelInfo.ParallelSN)} {t('W')}</span>
                                <span style={{ marginRight: '20px' }}>{calc.voltage(Vgrid1, protocol)} {t('Vac')}</span>
                                <span>{calc.frequency(Fgrid, protocol)} {t('Hz')}</span>
                            </div>
                            <div>
                                <span style={{ marginRight: '20px' }}>{calc.power(Pgrid2, protocol, ParallelInfo.IsParallel && !ParallelInfo.ParallelSN)} {t('W')}</span>
                                <span style={{ marginRight: '20px' }}>{calc.voltage(Vgrid2, protocol)} {t('Vac')}</span>
                                <span>{calc.frequency(Fgrid, protocol)} {t('Hz')}</span>
                            </div>
                            <div>
                                <span style={{ marginRight: '20px' }}>{calc.power(Pgrid3, protocol, ParallelInfo.IsParallel && !ParallelInfo.ParallelSN)} {t('W')}</span>
                                <span style={{ marginRight: '20px' }}>{calc.voltage(Vgrid3, protocol)} {t('Vac')}</span>
                                <span>{calc.frequency(Fgrid, protocol)} {t('Hz')}</span>
                            </div>
                        </div>
                    ) : (
                        <div style={{ top: '200px', left: '805px' }}>
                            <span style={{ marginRight: '20px' }}>{calc.power(Pgrid1, protocol)} {t('W')}</span>
                            <span style={{ marginRight: '20px' }}>{calc.voltage(Vgrid1, protocol)} {t('Vac')}</span>
                            <span>{calc.frequency(Fgrid, protocol)} {t('Hz')}</span>
                        </div>
                    )
            }
            {hasSmartPlug == false ? null : (
                <div style={{ top: '300px', left: '750px', display:"flex", flexDirection:"row"}}>
                    <span style={{ marginRight: '5px', whiteSpace: "nowrap"}}>{t("Smart Plug")}:</span>
                    <Button type="default" size="middle" style={{ backgroundColor: "#1d80b5", color: "white", marginRight: "5px" }} onClick={() => doSmartSwitch(1)}>
                        {t('Switch on')}
                        {smartPlugStatus == 1 ? <span style={{ color: 'lime', marginLeft: '5px' }}>✔</span> : null}
                    </Button>
                    <Button type="default" size="middle" style={{backgroundColor: "#1d80b5", color:"white", marginRight: "10px"}} onClick={() => doSmartSwitch(0)}>
                        {t('Switch off')}
                        {smartPlugStatus === 0 ? <span style={{ color: 'lime', marginLeft: '5px' }}>✔</span> : null}
                    </Button>
                    <Button type="default" size="middle" style={{backgroundColor: "#1d80b5", color:"white"}} onClick={() => doGetSmartSwitch()}>
                        {t('Get Status')}
                        {smartPlugStatus === 255 ? <span style={{ color: 'red', marginLeft: '5px' }}>(Offline/Error)</span> : null}
                    </Button>
                </div>
            )}            {/* SmartFlex Connect Override/Reject */}
            {(protocol == "Sungery" && snMapToSFCAssetID[SN] && showSFCComponent) ? (
                <div style={{top: '340px', left: '750px', display:"flex", flexDirection:"row"}}>
                    <SFCConfigurationAndSchedules 
                        assetId={SN} 
                        onDeviceDeleted={() => setShowSFCComponent(false)}
                    />
                </div>
            ) : null}
            {/* Eps数据 */}
            {
                protocol === 'Thinkpower' || protocol === 'Megarevo' || protocol === 'Sinexcel' || protocol === 'Megarevo-CESS' || protocol === 'Sungery' ?
                    (
                        <div style={{ top: '320px', left: '376px' }}>
                            <div>{calc.power(Peps1, protocol, ParallelInfo.IsParallel && !ParallelInfo.ParallelSN)} {t('W')}</div>
                            <div>{calc.power(Peps2, protocol, ParallelInfo.IsParallel && !ParallelInfo.ParallelSN)} {t('W')}</div>
                            <div>{calc.power(Peps3, protocol, ParallelInfo.IsParallel && !ParallelInfo.ParallelSN)} {t('W')}</div>
                            <div style={{ color: '#a6b7bf', fontSize: '16px' }}>{t('Backup Power(EPS)')}</div>
                        </div>
                    ) : (
                        <div style={{ top: '380px', left: '370px' }}>
                            <div>{calc.power(Peps1 + Peps2 + Peps3, protocol)} {t('W')}</div>
                            <div style={{ color: '#a6b7bf', fontSize: '16px' }}>{t('Backup Power(EPS)')}</div>
                        </div>
                    )
            }
            {/* Load数据 */}
            {
                protocol === 'Thinkpower' || protocol === 'Megarevo' || protocol === 'Sinexcel' || protocol === 'Megarevo-CESS' || protocol === 'Sungery' ?
                    (
                        <div style={{ top: '315px', left: '640px' }}>
                            <div>{calc.power(Pload1, protocol, ParallelInfo.IsParallel /*&& !ParallelInfo.ParallelSN*/)} {t('W')}</div>
                            <div>{calc.power(Pload2, protocol, ParallelInfo.IsParallel /*&& !ParallelInfo.ParallelSN*/)} {t('W')}</div>
                            <div>{calc.power(Pload3, protocol, ParallelInfo.IsParallel /*&& !ParallelInfo.ParallelSN*/)} {t('W')}</div>
                            <div style={{ color: '#a6b7bf', fontSize: '16px' }}>{t('Consumption Power')}</div>
                        </div>
                    ) : (
                        <div style={{ top: '375px', left: '640px' }}>
                            <div>{calc.power(Pload1 + Pload2 + Pload3, protocol)} {t('W')}</div>
                            <div style={{ color: '#a6b7bf', fontSize: '16px' }}>{t('Consumption Power')}</div>
                        </div>
                    )
            }
            {/* <div style={{ top: '400px', left: '-80px' }}> 
                <div>{CreateTime}</div>
            </div> */}

        </div>
    )

    //Sungery Parallel info
    const len = invData && invData.Parallels.length;
    const ParallelSelectOptions = [];
    let parallelTypeTitle = '';
    if (invData && invData.Parallels.length > 1) {  //Single Parallels
        if (invData.Parallels[len - 1].ParaMode < 5) {
            parallelTypeTitle = t('Single Parallels');
            invData.Parallels.forEach(v => {
                ParallelSelectOptions.push({ value: v.SN, label: v.SN + (v.ExtCtGetHostEn ? t('(Master)') : '') })
            })
        } else if (invData.Parallels[len - 1].ParaMode >= 5) {  //3-Phase Parallels
            parallelTypeTitle = t('3-Phase Parallels');
            let groupOption = [];
            let paraMode = invData.Parallels[0].ParaMode;
            invData.Parallels.forEach((v, index) => {
                let paraLabel = paraMode == 5 ? t('A Phase') : paraMode == 6 ? t('B Phase') : paraMode == 7 ? t('C Phase') : t('No Phase')
                if (v.ParaMode == paraMode) {
                    groupOption.push({ value: v.SN, label: v.SN + (v.ExtCtGetHostEn ? t('(Master)') : '') })
                } else {
                    ParallelSelectOptions.push({ label: paraLabel, options: groupOption })
                    paraMode = v.ParaMode;
                    groupOption = [{ value: v.SN, label: v.SN + (v.ExtCtGetHostEn ? t('(Master)') : '') }]
                }
                if (index == invData.Parallels.length - 1) {
                    paraLabel = v.ParaMode == 5 ? t('A Phase') : v.ParaMode == 6 ? t('B Phase') : v.ParaMode == 7 ? t('C Phase') : t('No Phase')
                    ParallelSelectOptions.push({ label: paraLabel, options: groupOption })
                }
            });
        }
    }


    return (
        <div className="runtime-monitor">
            <div className="search">   {/* 搜索栏 */}
                <span>{t('Select Inverter')}</span>
                <Select
                    showSearch
                    placeholder={t("Enter Inverter Name")}
                    defaultActiveFirstOption={false}
                    showArrow={true}
                    filterOption={true}
                    onSelect={(value, option) => {
                        handleSelectSN(value, option);
                        setParallelInfo({ IsParallel: false, ParallelSN: 0 });
                    }}
                    value={SN}
                    style={{ width: '200px' }}
                >{inverterSelectOptions}</Select>
                <span style={{ display: invData && invData.IsParallel ? 'block' : 'none' }}>{parallelTypeTitle}</span>
                {/* {ParallelSelectOptions} */}
                <div className="parallel-info" style={{
                    display: invData && invData.IsParallel ? 'block' : 'none'
                }}>
                    <Select style={{ width: '200px' }} defaultValue={0} value={ParallelInfo.ParallelSN} onChange={value => setParallelInfo({ IsParallel: !value, ParallelSN: value })} options={[
                        { label: t('Parallels'), value: 0 },
                        ...ParallelSelectOptions]} />
                </div>
            </div>
            <div className="panel">    {/* 面板 */}
                <div className="infoBlock">     {/* Solar Yielding */}
                    <div className="infoTitle" style={{ backgroundColor: '#82b2c7' }}>
                        {t('Solar Yielding')}
                    </div>
                    <div className="infoContent" onClick={handleClickSolar} style={{ display: solarIndex == 0 ? 'block' : 'none' }}>
                        <div className="content-left">
                            <img src="images/inverter/solar.png"></img>
                        </div>
                        <div className="content-right">
                            <div style={{ fontSize: '18px' }}>{calc.energy(EDay, protocol)} kWh</div>
                            <div style={{ fontSize: '14px', color: '#a6b7bf' }}>{t('Today Yielding')}</div>
                            <div style={{ fontSize: '18px' }}>{calc.energy(ETotal, protocol)} kWh</div>
                            <div style={{ fontSize: '14px', color: '#a6b7bf' }}>{t('Total Yielding')}</div>
                        </div>
                    </div>
                    <div className="infoContent" onClick={handleClickSolar} style={{ display: solarIndex == 1 ? 'block' : 'none' }}>
                        <div className="content-left">
                            <div style={{ color: '#FF718F', fontSize: '14px', marginBottom: '5px' }}>
                                {invData ? calSolarRatio(EDayLOAD, EDay) : '--'}% {t('Load Today')}
                            </div>
                            <div style={{ color: '#5CC9A0', fontSize: '14px', marginBottom: '5px' }}>
                                {invData ? calSolarRatio(EDayBatChrg, EDay) : '--'}% {t('Charge Today')}
                            </div>
                            <div style={{ color: '#F2A474', fontSize: '14px', marginBottom: '5px' }}>
                                {invData ? calSolarRatio(EDayToGrid, EDay) : '--'}% {t('Export Today')}
                            </div>
                            <div style={{ fontWeight: 'bold', fontSize: '16px' }}>{t('Today')} {calc.energy(EDay, protocol)} kWh</div>
                        </div>
                        <div className="content-right">
                            {EDay != 0 ? <ReactECharts ref={chart1} option={option1} className="chart" /> : null}
                        </div>
                    </div>
                    <div className="infoContent" onClick={handleClickSolar} style={{ display: solarIndex == 2 ? 'block' : 'none' }}>
                        <div className="content-left">
                            <div style={{ color: '#FF718F', fontSize: '14px', marginBottom: '5px' }}>
                                {invData ? calSolarRatio(ETotalLOAD, ETotal) : '--'}% {t('Load Total')}
                            </div>
                            <div style={{ color: '#5CC9A0', fontSize: '14px', marginBottom: '5px' }}>
                                {invData ? calSolarRatio(ETotalBatChrg, ETotal) : '--'}% {t('Charge Total')}
                            </div>
                            <div style={{ color: '#F2A474', fontSize: '14px', marginBottom: '5px' }}>
                                {invData ? calSolarRatio(ETotalToGrid, ETotal) : '--'}% {t('Export Total')}
                            </div>
                            <div style={{ fontWeight: 'bold', fontSize: '16px' }}>{t('Total')} {calc.energy(ETotal, protocol)} kWh</div>
                        </div>
                        <div className="content-right">
                            {ETotal != 0 ? <ReactECharts ref={chart2} option={option2} className="chart" /> : null}
                        </div>
                    </div>
                </div>
                <div className="infoBlock">     {/* battery Charge/Discharge */}
                    <div className="infoTitle" style={{ backgroundColor: '#d6a2ae' }}>
                        {batteryIndex == 0 ? t('Battery Charge') : t('Battery Discharge')}
                    </div>
                    <div className="infoContent" onClick={handleClickBattery} style={{ display: batteryIndex == 0 ? 'block' : 'none' }}>
                        <div className="content-left">
                            <img src="images/inverter/battery_charge.png" alt={t('Battery Charge')}></img>
                        </div>
                        <div className="content-right">
                            <div style={{ fontSize: '18px' }}>{calc.energy(EDayBatChrg, protocol)} kWh</div>
                            <div style={{ fontSize: '14px', color: '#a6b7bf' }}>{t('Today Charge')}</div>
                            <div style={{ fontSize: '18px' }}>{calc.energy(ETotalBatChrg, protocol)} kWh</div>
                            <div style={{ fontSize: '14px', color: '#a6b7bf' }}>{t('Total Charge')}</div>
                        </div>
                    </div>
                    <div className="infoContent" onClick={handleClickBattery} style={{ display: batteryIndex == 1 ? 'block' : 'none' }}>
                        <div className="content-left">
                            <img src="images/inverter/battery_discharge.png" alt={t('Battery Discharge')}></img>
                        </div>
                        <div className="content-right">
                            <div style={{ fontSize: '18px' }}>{calc.energy(EDayBatDischrg, protocol)} kWh</div>
                            <div style={{ fontSize: '14px', color: '#a6b7bf' }}>{t('Today Discharge')}</div>
                            <div style={{ fontSize: '18px' }}>{calc.energy(ETotalBatDischrg, protocol)} kWh</div>
                            <div style={{ fontSize: '14px', color: '#a6b7bf' }}>{t('Total Discharge')}</div>
                        </div>
                    </div>
                </div>
                <div className="infoBlock">     {/* Feed-in Energy / Import */}
                    <div className="infoTitle" style={{ backgroundColor: '#92b5c9' }}>
                        {gridIndex == 0 ? t('Feed-in Energy') : t('Import')}
                    </div>
                    <div className="infoContent" onClick={handleClickGrid} style={{ display: gridIndex == 0 ? 'block' : 'none' }}>
                        <div className="content-left">
                            <img src="images/inverter/grid_export.png" alt={t('Grid Export')}></img>
                        </div>
                        <div className="content-right">
                            <div style={{ fontSize: '18px' }}>{calc.energy(EDayToGrid, protocol)} kWh</div>
                            <div style={{ fontSize: '14px', color: '#a6b7bf' }}>{t('Today Export')}</div>
                            <div style={{ fontSize: '18px' }}>{calc.energy(ETotalToGrid, protocol)} kWh</div>
                            <div style={{ fontSize: '14px', color: '#a6b7bf' }}>{t('Total Export')}</div>
                        </div>
                    </div>
                    <div className="infoContent" onClick={handleClickGrid} style={{ display: gridIndex == 1 ? 'block' : 'none' }}>
                        <div className="content-left">
                            <img src="images/inverter/grid_import.png" alt={t('Grid Import')}></img>
                        </div>
                        <div className="content-right">
                            <div style={{ fontSize: '18px' }}>{calc.energy(EDayFromGrid, protocol)} kWh</div>
                            <div style={{ fontSize: '14px', color: '#a6b7bf' }}>{t('Today Import')}</div>
                            <div style={{ fontSize: '18px' }}>{calc.energy(ETotalFromGrid, protocol)} kWh</div>
                            <div style={{ fontSize: '14px', color: '#a6b7bf' }}>{t('Total Import')}</div>
                        </div>
                    </div>
                </div>
                <div className="infoBlock">     {/* Consumption */}
                    <div className="infoTitle" style={{ backgroundColor: '#6fad92' }}>
                        {t('Consumption')}
                    </div>
                    <div className="infoContent">
                        <div className="content-left">
                            <img src="images/inverter/load.png" alt={t('Load')}></img>
                        </div>
                        <div className="content-right">
                            <div style={{ fontSize: '18px' }}>{calc.energy(EDayLOAD, protocol)} kWh</div>
                            <div style={{ fontSize: '14px', color: '#a6b7bf' }}>{t('Today Usage')}</div>
                            <div style={{ fontSize: '18px' }}>{calc.energy(ETotalLOAD, protocol)} kWh</div>
                            <div style={{ fontSize: '14px', color: '#a6b7bf' }}>{t('Total Usage')}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flow">     {/* System Information */}
                <div className="flow-title">{t('System Information')}</div>
                {bms_sys_flow}
            </div>
            {/* related-inverters */}
            {invData && invData.Inverters && invData.Inverters.length > 1 &&
                <div className="related-inverters">
                    <Table
                        columns={[{
                            title: t('SN'),
                            width: 250,
                            dataIndex: 'SN',
                        }].concat(
                            protocol === 'Senergy' ?
                                [{
                                    title: t('Vpv'),
                                    width: 150,
                                    dataIndex: 'VMPPT1',
                                    render: (v, r) => {
                                        return v != null ? `${calc.voltage(v, protocol)}${t('V')}` : '--'
                                    }
                                }, {
                                    title: t('Ppv'),
                                    width: 150,
                                    dataIndex: 'PDC',
                                    render: (v, r) => {
                                        return v != null ? `${calc.power(v, protocol)}${t('W')}` : '--'
                                    }
                                }] :
                                [{
                                    title: t('Vpv1'),
                                    width: 150,
                                    dataIndex: 'VMPPT1',
                                    render: (v, r) => {
                                        return v != null ? `${calc.voltage(v, protocol)}${t('V')}` : '--'
                                    }
                                }, {
                                    title: t('Ppv1'),
                                    width: 150,
                                    dataIndex: 'PMPPT1',
                                    render: (v, r) => {
                                        return v != null ? `${calc.power(v, protocol)}${t('W')}` : '--'
                                    }
                                }, {
                                    title: t('Vpv2'),
                                    width: 150,
                                    dataIndex: 'VMPPT2',
                                    render: (v, r) => {
                                        return v != null ? `${calc.voltage(v, protocol)}${t('V')}` : '--'
                                    }
                                }, {
                                    title: t('Ppv2'),
                                    width: 150,
                                    dataIndex: 'PMPPT2',
                                    render: (v, r) => {
                                        return v != null ? `${calc.power(v, protocol)}${t('W')}` : '--'
                                    }
                                }, {
                                    title: t('Vpv3'),
                                    width: 150,
                                    dataIndex: 'VMPPT3',
                                    render: (v, r) => {
                                        return v != null ? `${calc.voltage(v, protocol)}${t('V')}` : '--'
                                    }
                                }, {
                                    title: t('Ppv3'),
                                    width: 150,
                                    dataIndex: 'PMPPT3',
                                    render: (v, r) => {
                                        return v != null ? `${calc.power(v, protocol)}${t('W')}` : '--'
                                    }
                                }]).concat([{
                                    title: t('SOC'),
                                    width: 150,
                                    dataIndex: 'SOC',
                                    render: (v, r) => {
                                        return v != null ? `${calc.soc(v, protocol)}%` : '--'
                                    }
                                }, {
                                    title: t('Vbat'),
                                    width: 150,
                                    dataIndex: 'VBat',
                                    render: (v, r) => {
                                        return v != null ? `${calc.voltage(v, protocol)}${t('V')}` : '--'
                                    }
                                }, {
                                    title: t('Pcharge'),
                                    width: 150,
                                    dataIndex: 'PBat',
                                    render: (v, r) => {
                                        if (protocol === 'Senergy' || protocol === 'Thinkpower' || protocol === 'Sungery') {
                                            return v < 0 ? `${Math.abs(calc.power(v, protocol))}${t('W')}` : `0${t('W')}`
                                        } else if (protocol === 'Megarevo' || protocol === 'Sinexcel' || protocol === 'Megarevo-CESS') {
                                            return v > 0 ? `${calc.power(v, protocol)}${t('W')}` : `0${t('W')}`
                                        } else {
                                            return `0${t('W')}`
                                        }
                                    }
                                }, {
                                    title: t('Pdischarge'),
                                    width: 150,
                                    dataIndex: 'PBat',
                                    render: (v, r) => {
                                        if (protocol === 'Senergy' || protocol === 'Thinkpower' || protocol === 'Sungery') {
                                            return v > 0 ? `${calc.power(v, protocol)}${t('W')}` : `0${t('W')}`
                                        } else if (protocol === 'Megarevo' || protocol === 'Sinexcel' || protocol === 'Megarevo-CESS') {
                                            return v < 0 ? `${Math.abs(calc.power(v, protocol))}${t('W')}` : `0${t('W')}`
                                        } else {
                                            return `0${t('W')}`
                                        }
                                    }
                                }, {
                                    title: t('Peps'),
                                    width: 150,
                                    dataIndex: 'PAC1EPS',
                                    render: (v, r) => {
                                        return v != null ? `${calc.power(r['PAC1EPS'] + r['PAC2EPS'] + r['PAC3EPS'], protocol)}${t('W')}` : `0${t('W')}`
                                    }
                                }, {
                                    title: t('DataTime'),
                                    width: 250,
                                    dataIndex: 'CreateTime',
                                    render: (v, r) => {
                                        return <span>{moment(v).format('YYYY-MM-DD HH:mm:ss')}</span>
                                    }
                                }])}
                        dataSource={invData && invData.Inverters}
                        size='small'
                        pagination={false}
                    />
                </div>
            }
            <div>
                <div className="power">    {/* Input&Output Power */}
                    <div className="power-title">{t('Input&Output Power')}</div>
                    <div className="power-powerDate">
                        <DatePicker
                            defaultValue={moment()}
                            value={moment(powerDate)}
                            onChange={(_, ds) => {refPowerDate.current=ds; setPowerDate(ds)}}
                            allowClear={false}
                        />
                    </div>
                    <div className="power-chart">
                        <ReactECharts ref={powerChart} option={powerOption} style={{ height: 320 }} />
                    </div>
                </div>
                <div className="siderbar">  {/* notice 和 revenue */}
                    <div className="notice">
                        <div className="notice-title">{t('Notice')}</div>
                        <div className="notice-content">{t('None')}</div>
                    </div>
                    <div className="revenue">
                        <div className="revenue-title">{t('Other Revenue')}</div>
                        <div className="revenue-box CO2">
                            <img height="72" src="images/inverter/co2.png"></img>
                            <div className="box-num">
                                <span>{invData && invData.ETotal > 0 ? ((protocol == 'Thinkpower' ? invData.ETotal / 10 : invData.ETotal) / 1.003).toFixed(2) : 0} {t('kG')}</span><br />
                                <span>{t('CO2 Reduction')}</span>
                            </div>
                        </div>
                        <div className="revenue-box coal">
                            <img height="72" src="images/inverter/coal.png"></img>
                            <div className="box-num">
                                <span>{invData && invData.ETotal > 0 ? ((protocol == 'Thinkpower' ? invData.ETotal / 10 : invData.ETotal) / 2.5).toFixed(2) : 0} {t('kG')}</span><br />
                                <span>{t('Coal Saving')}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="energy">    {/* Energy Overview */}
                <div className="energy-title">
                    {t('Energy Overview')} {size == 'month' ? '(' + moment(energyDate).format('YYYY-MM') + ')' : size == 'year' ? '(' + moment(energyDate).format('YYYY') + ')' : null}
                </div>
                <div className="energy-date" style={{ display: size == 'total' ? 'none' : 'block' }}>
                    <DatePicker
                        picker={size == "month" ? 'month' : 'year'}
                        onChange={(_, ds) => {refEnergyDate.current = ds; setEnergyDate(ds)}}
                        defaultValue={moment()}
                        value={moment(energyDate)}
                        allowClear={false}
                    />
                </div>
                <div className="energy-btn">
                    <Radio.Group value={size} optionType='button' buttonStyle='solid' onChange={e => {refSize.current = e.target.value; setSize(e.target.value)}}>
                        <Radio.Button value="monthly">{t('Month')}</Radio.Button>
                        <Radio.Button value="yearly">{t('Year')}</Radio.Button>
                        <Radio.Button value="all-years">{t('Total')}</Radio.Button>
                    </Radio.Group>
                </div>
                <div className="energy-chart">
                    <ReactECharts ref={energyChart} option={energyOption} style={{ height: 360 }} />
                </div>
            </div>
            {/* 点击逆变器时显示逆变器列表 */}
            <Modal
                title={t('Inverters List')}
                visible={showInvertersList}
                cancelText={t('Cancel')}
                okText={t('OK')}
                mask={true}
                maskClosable={false}
                width={420}
                footer={null}
                onCancel={() => setShowInvertersList(false)}
            >
                <Table
                    columns={[{
                        title: "",
                        width: 20,
                        fixed: 'left',
                        render: (v, r, idx) => {
                            return idx + 1
                        }
                    }, {
                        title: "SN",
                        dataIndex: "SN",
                        width: 100,
                    }]}
                    tableLayout="fixed"
                    bordered={true}
                    size="small"
                    pagination={false}
                    rowKey="ID"
                    dataSource={invData && invData.Inverters}
                />
            </Modal>
            {loading && (
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.7)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1000,
                }}>
                    <Spin size="large" />
                </div>
            )}
            {sns ? <WebSocketController 
                baseUrl={config.wssInverterUrl}
                SNs={sns}
                onError={handleInverterWSError}
                onData={handleInverterWSDate}
            />: null}
            {batSNs ? <WebSocketController 
                baseUrl={config.wssUrlV2}
                SNs={batSNs}
                onError={handleBatteryWSError}
                onData={handleBatteryWSDate}
            /> : null}
        </div>
    )
}

export default RealtimeMonitor;